import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect, Link, useParams } from 'react-router-dom'
import classnames from 'classnames'
import {
  Container, Spinner, Table, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Card, CardBody, Badge, CardHeader,
  Label, FormGroup, Input, CustomInput,
  Nav, NavItem, NavLink,
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import moment from 'moment'
import { Editor } from 'react-draft-wysiwyg'
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import MaskedInput from '../../../components/Template/Input/MaskedInput'
import DatePicker from 'react-datepicker'
import Select from '../../../components/Template/Input/Select'
import CreatableSelect from 'react-select/creatable'
import DataTable from '../../../components/Template/Table/DataTable'
import { People, PeoplePicker } from '@microsoft/mgt-react'
import { currencyFormatter } from '../../../utils/currencyFormatter'
import { getProject, getProjectContract, getProjectProducts, getTeam, getProjectTeam, getAval, getAprov } from '../../../store/ducks/technicalDep'
import { getLegalSolicitations, postLegalSolicitation, getOfficialLettersCreated, postOfficialLetterCreated, getOfficialLettersReceived, postOfficialLetterReceived, updateOfficialLetter, generateLegalDemandForOficio } from '../../../store/ducks/management'
import StepStatus from '../../../components/Template/Progress/StepStatus'
import { notifySuccess, notifyError } from '../../../utils/notify'
import powerAppsApi from '../../../services/powerapps/index'
import oikosApi from '../../../services/oikos'
import { getOikosFileUrl } from '../../../utils/linksOikos/link'
import Activities from './Activities'
import { graphClient } from '../../../store/sagas/auth'
import AddContractFiles from '../../../components/Template/Files/AddContractFiles'
import AddFiles from '../../../components/Template/Files/AddFiles'
import DocTab from '../../../components/Template/Doc/DocTab'
import TimelineStatusProduto from '../../../components/TimelineStatusProduto/TimelineStatusProduto'
import EvePag from '../../../components/Template/Doc/EvePag'
import Prod from '../../../components/Template/Doc/Prod'
import OrcItemsProj from '../../../components/Template/Doc/OrcItemsProj'
import StakeProj from '../../../components/Template/Tab/StakeProj'
import DBSwitch from '../../../components/Template/Input/DBSwitch'
import { getProdutoFinalDoc, getRegs, insOrUp, selectValues } from '../../../utils/fc'
import qs from 'qs'
import { InputLabel } from '@mui/material'
import ProjectFinancialResume from '../../../components/Template/ProjectFinancialResume/ProjectFinancialResume'
import Vagas from '../../../components/Template/Doc/Vagas'
import Edit from '@material-ui/icons/Edit'
import CheckIcon from '@material-ui/icons/Check'
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import CloseIcon from '@mui/icons-material/Close';
import ModalConfirmacao from '../../../components/Modals/ModalConfirmacao/ModalConfirmacao'
import Bordero from '../../Financial/Bordero'
import { update } from 'lodash'
import MeusFornecedores from '../../MeusFornecedores'
import EquiProj from '../../../components/Template/Doc/EquiProj.js'
import BlurOverlay from '../../../components/TestPhaseComponent/BlurOverlay'
import ProjLegalDetailsModal from './components/ProjLegalDetailsModal'
import MarketingCaseForm from './components/MarketingCaseForm'
import MarketingPesquisaForm from './components/MarketingPesquisaForm'
import ProjDadosTab from './components/ProjDadosTab'
import {
  CREATED_STATUS_OPTIONS,
  RECEIVED_STATUS_OPTIONS,
  CREATED_STATUS_COLOR_MAP,
  RECEIVED_STATUS_COLOR_MAP,
  GERENCIA_EMAIL_OPTIONS,
  PROJECT_FORWARD_EMAIL_OPTIONS,
  getNextOficioNumber,
  getRowId,
  buildLegalDemandDefaults,
  MODAL_SELECT_PROPS,
  MODAL_MULTI_SELECT_PROPS,
  EDITOR_TOOLBAR,
  EDITOR_WRAPPER_STYLE,
  EDITOR_INNER_STYLE,
} from '../../Management/OfficialLetters/constants'
import '../../Management/OfficialLetters/modalForms.css'
import ModalDatePicker from '../../Management/OfficialLetters/ModalDatePicker'
import LegalDemandOptionsModal from '../../Management/OfficialLetters/LegalDemandOptionsModal'
import OfficialLetterSubmitOverlay from '../../Management/OfficialLetters/SubmitOverlay'
import endPoints1Api from '../../../services/end_points_1'

class FastEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: props.editorState || EditorState.createEmpty()
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.editorState !== prevProps.editorState && this.props.editorState.getCurrentContent().getPlainText() === '') {
      this.setState({ editorState: this.props.editorState });
    }
  }

  handleChange = (editorState) => {
    this.setState({ editorState });
    if (this.props.onChange) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.props.onChange(editorState);
      }, 300);
    }
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
  }

  render() {
    return (
      <Editor
        editorState={this.state.editorState}
        onEditorStateChange={this.handleChange}
        toolbar={this.props.toolbar || EDITOR_TOOLBAR}
        toolbarClassName={this.props.toolbarClassName || 'rdw-toolbar-oficios'}
        editorStyle={this.props.editorStyle || EDITOR_INNER_STYLE}
        localization={this.props.localization || { locale: 'pt' }}
      />
    );
  }
}

const rawToHtml = (editorState) => {
  const raw = convertToRaw(editorState.getCurrentContent())
  return raw.blocks.map(block => block.text.trim() ? `<p>${block.text}</p>` : '').join('')
}

const parseDate = (value) => (value ? moment(value).toDate() : null)

const stripHtml = (html) => {
  if (!html) return ''
  const tmp = document.createElement('div')
  tmp.innerHTML = html
  return tmp.textContent || tmp.innerText || ''
}

const htmlToEditorState = (html) => (
  EditorState.createWithContent(ContentState.createFromText(stripHtml(html)))
)

const projPriorities = [
  { label: 'Urgente', value: 'Urgente' },
  { label: 'Importante', value: 'Importante' },
  { label: 'Sugestão', value: 'Sugestão' },
]

const projSubjectOptions = [
  { label: 'Análise de Contrato', value: 'Análise de Contrato' },
  { label: 'Elaboração de Contrato', value: 'Elaboração de Contrato' },
  { label: 'Parecer Jurídico', value: 'Parecer Jurídico' },
  { label: 'Consultoria Jurídica', value: 'Consultoria Jurídica' },
  { label: 'Dúvida', value: 'Dúvida' },
  { label: 'Outros', value: 'Outros' },
]

class Project extends Component {
  constructor(props) {
    super(props)
    this.state = {
      refreshTimeline: 0,
      editProjectTeamDialogIsOpen: false,
      editProjectTeamPeople: [],
      confirmProjAberturaModalOpen: false,
      allTrue: false,

      isEditing: {
        nome: false,
        situacao: false,
        latitude: false,
        longitude: false,
      },
      selOptionsStatus: [],
      editableProjectData: {
        proj_nome: '',
        projSituacao_id: null,
        proj_lat: null,
        proj_lon: null,
        proj_dtIniPrev: null
      },

      addProductModalIsOpen: false,
      addProductData: {},
      recList: [],

      reviewedTabs: {},
      stakeProjRefreshAt: 0,

      addActivityModalIsOpen: false,
      addActivityData: {},

      addDocumentModalIsOpen: false,
      addMailModalIsOpen: false,

      getDocumentsIsLoading: false,
      documents: [],

      documentsProducts: [],
      additiveContracts: null,

      emailData: {},

      selTpStatus: false,

      productsOfProject: {},

      projectState: {},

      // Solicitações Tab States
      projActiveSubTab: 'legal',
      projMarketingSubTab: 'case',
      selectedProjectTab: 0,
      expandContrFornId: null,
      expandCompraCotacaoId: null,
      expandContrFornRequestKey: 0,
      projLegalModalOpen: false,
      projCreateLetterModalOpen: false,
      projReceiveLetterModalOpen: false,

      // Form: Solicitação Jurídica
      projLegalRequester: '',
      projLegalRequesterError: '',
      projLegalSubject: null,
      projLegalSubjectError: '',
      projLegalPriority: null,
      projLegalPriorityError: '',
      projLegalDate: '',
      projLegalDateError: '',
      projLegalDateOpen: false,
      projLegalDescription: EditorState.createEmpty(),
      projLegalDescriptionError: '',
      projLegalFatoGerador: '',
      projLegalAttachment: null,
      projLegalDetailsModalOpen: false,
      projLegalSelected: {},
      projLegalResponseDescription: EditorState.createEmpty(),
      projLegalResponseDescriptionError: '',
      projLegalResponseAttachment: null,

      // Form: Criar Ofício
      projCreateNumero: '',
      projCreateSigner: '',
      projCreateSignerError: '',
      projCreateSubject: '',
      projCreateSubjectError: '',
      projCreateDate: '',
      projCreateDateError: '',
      projCreateSendDate: '',
      projCreateReceiveDate: '',
      projCreateRecipient: '',
      projCreateRecipientError: '',
      projCreateBody: EditorState.createEmpty(),
      projCreateBodyError: '',
      projCreateAttachment: null,
      projCreateObservations: '',
      projCreateGerarDemanda: false,
      projCreateDemandaJuridica: null,
      projCreateDemandaModalOpen: false,
      projCreateDemandaDefaults: null,
      projTableDemandaModalOpen: false,
      projTableDemandaRow: null,
      projTableDemandaDefaults: null,
      projCreateLinkReceived: null,
      projRespondToReceived: null,

      projEditCreatedModalIsOpen: false,
      projEditingCreatedRow: null,
      projEditCreatedNumero: '',
      projEditCreatedStatus: 'Em elaboração',
      projEditCreatedSigner: '',
      projEditCreatedSubject: '',
      projEditCreatedDate: '',
      projEditCreatedSendDate: '',
      projEditCreatedReceiveDate: '',
      projEditCreatedRecipient: '',
      projEditCreatedBody: EditorState.createEmpty(),
      projEditCreatedObservations: '',
      projEditCreatedLinkReceived: null,

      projEditReceivedModalIsOpen: false,
      projEditingReceivedRow: null,
      projEditReceivedNumero: '',
      projEditReceivedSender: '',
      projEditReceivedDate: '',
      projEditReceivedLetterDate: '',
      projEditReceivedSubjectBody: EditorState.createEmpty(),
      projEditReceivedForwardDepartments: [],
      projEditReceivedCcEmail: '',
      projEditReceivedObservations: '',
      projEditReceivedTemPrazo: false,
      projEditReceivedPrazo: '',

      // Form: Receber Ofício
      projReceiveNumero: '',
      projReceiveSender: '',
      projReceiveSenderError: '',
      projReceiveDate: '',
      projReceiveDateError: '',
      projReceiveLetterDate: '',
      projReceiveLetterDateError: '',
      projReceiveSubjectBody: EditorState.createEmpty(),
      projReceiveSubjectBodyError: '',
      projReceiveForwardDepartments: [],
      projReceiveForwardDepartmentsError: '',
      projReceiveCcEmail: '',
      projReceiveTemPrazo: false,
      projReceivePrazo: '',
      projReceiveAttachment: null,
      projReceiveObservations: '',
      projReceiveGerarDemanda: false,
      projReceiveDemandaJuridica: null,
      projReceiveDemandaModalOpen: false,
      projReceiveDemandaDefaults: null,
      projTableReceivedDemandaModalOpen: false,
      projTableReceivedDemandaRow: null,
      projTableReceivedDemandaDefaults: null,

      // Lists
      projLegalList: [],
      projCreatedLettersList: [],
      projReceivedLettersList: [],
      pfOptions: [],
    }

    this.filesRef = React.createRef()
    this.prodFinalFileRef = React.createRef()
  }

  componentDidMount() {
    const { getProject, getProjectProducts, getProjectTeam, getProjectContract, getTeam, getAval, getAprov } = this.props
    const { project } = this.props.location
    const proj_id = project?.proj_id || this.props.match.params.id

    if (proj_id) {
      getProject(proj_id)
      // getProjectProducts(proj_id)
      getTeam()
      getProjectTeam(proj_id)
      console.log('project contrato: ', project?.contrato_id)
      getProjectContract(project?.contrato_id)
      this.preloading(proj_id)
    } else {
      return <Redirect to="/" />
    }
    this.getDocuments()
    getAval()
    getAprov()
    this.fetchPfs()

    const getOikosId = async (mail) => {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'pf',
        data: {
          pf_emailProf: mail
        },
        fields: {
        }
      })}`)

      this.setState({
        userOikosId: res.data[0].pf_id, userCargo: res.data[0].pf_cargo,
        projLegalRequester: res.data[0].pf_nome || res.data[0].pf_nomeExibicao || res.data[0].pf_id,
        editableProjectData: {
          proj_nome: project?.proj_nome || '',
          projSituacao_id: project?.projSituacao_id || null,
        }
      })
    }
    getOikosId(this.props.auth.user.mail);

    // Buscar opções de situação do projeto da tabela projSituacao
    const getSituacaoOptions = async () => {
      try {
        const res = await oikosApi.get(`/?${qs.stringify({
          action: 'get',
          table: 'projSituacao',
          data: {
            projSituacao_ativo: 1,
          },
        })}`)
        if (res.data) {
          const allowedIds = [2, 3, 4] // Em andamento, Em encerramento, Concluído
          const labelOverrides = { 3: 'Em encerramento' }
          const options = res.data
            .filter(item => allowedIds.includes(Number(item.projSituacao_id)))
            .map(item => ({
              value: Number(item.projSituacao_id),
              label: labelOverrides[Number(item.projSituacao_id)] || item.projSituacao_desc,
            }))
          this.setState({ selOptionsStatus: options })
        }
      } catch (e) {
        console.log('Erro ao buscar opções de situação:', e)
      }
    }
    getSituacaoOptions();
  }

  loadProjSolicitationsAndLetters = (contrato_id) => {
    if (!contrato_id) return
    this.props.getLegalSolicitations(contrato_id)
    this.props.getOfficialLettersCreated(contrato_id)
    this.props.getOfficialLettersReceived(contrato_id)
  }

  fetchPfs = async () => {
    try {
      const res = await getRegs('pf', { pf_ativo: 1 }, ['pf_id', 'pf_nome'])
      const options = res.map(p => ({ label: p.pf_nome, value: p.pf_nome }))
      this.setState({ pfOptions: options, pfList: res })
    } catch (error) {
      console.log(error)
    }
  }

  componentDidUpdate(prevProps, prevState) {

    // Check if the data part of the state has changed
    if (Object.keys(this.state.reviewedTabs).length > 0 &&
      prevState.reviewedTabs !== this.state.reviewedTabs &&
      this.state.projectState.projSituacao_id <= 1) {
      const allTrue = Object.values(this.state.reviewedTabs).every(item => item);
      // Only update the state if all keys are true and the modal is not already open
      if (allTrue && !this.state.confirmProjAberturaModalOpen) {
        this.setState({ confirmProjAberturaModalOpen: true });
      }
      if (allTrue) {
        this.setState({ allTrue: true })
      }
    }

    const contratoId = this.props.technicalDep.projectContract?.contrato_id
      || this.state.projectState?.contrato_id
    const prevContratoId = prevProps.technicalDep.projectContract?.contrato_id
      || prevState.projectState?.contrato_id
    if (contratoId && String(contratoId) !== String(prevContratoId)) {
      if (!this.props.technicalDep.projectContract?.contrato_id) {
        this.props.getProjectContract(contratoId)
      }
      this.loadProjSolicitationsAndLetters(contratoId)
    }

    const {
      postOfficialLetterCreatedIsLoading,
      postOfficialLetterReceivedIsLoading,
      postOfficialLetterCreatedError,
      postOfficialLetterReceivedError,
    } = this.props

    if (
      prevProps.postOfficialLetterCreatedIsLoading
      && !postOfficialLetterCreatedIsLoading
      && !postOfficialLetterCreatedError
      && this.state.projCreateLetterModalOpen
    ) {
      this.toggleProjCreateLetterModal()
    }

    if (
      prevProps.postOfficialLetterReceivedIsLoading
      && !postOfficialLetterReceivedIsLoading
      && !postOfficialLetterReceivedError
      && this.state.projReceiveLetterModalOpen
    ) {
      this.toggleProjReceiveLetterModal()
    }
  }

  markReviewed = (tabName) => {
    this.setState(prev => ({
      ...prev,
      reviewedTabs: { ...prev.reviewedTabs, [tabName]: true }
    }));
  };

  toggleEditField = (field, toggle) => {
    this.setState(prev => ({
      isEditing: {
        ...prev.isEditing,
        [field]: toggle
      }
    }))
  }

  handleEditableChange = (field, value) => {
    this.setState(prev => ({
      editableProjectData: {
        ...prev.editableProjectData,
        [field]: value
      }
    }))
  }

  handleOpenProject = async () => {
    console.log(this.state.editableProjectData.proj_dtIniPrev, this.state.projectState.proj_dtIniPrev)

    if (!this.state.editableProjectData.proj_dtIniPrev && !this.state.projectState.proj_dtIniPrev) {
      return notifyError('A data de início prevista do projeto é obrigatória para abrir o projeto. Por favor, preencha a data de início prevista para prosseguir.')
    }
    const updateProj = {
      action: 'update',
      table: 'proj',
      data: {
        proj_id: this.state.projectState.proj_id,
        proj_dtIniPrev: this.state.editableProjectData.proj_dtIniPrev || this.state.projectState.proj_dtIniPrev,
        projSituacao_id: 2,
      }
    }

    const projUpdated = await oikosApi.post('/', updateProj)

    const updateContrato = {
      action: 'update',
      table: 'contrato',
      data: {
        contrato_id: this.state.projectState.contrato_id,
        contrato_projAbert: 1,
      }
    }

    const contractUpdated = await oikosApi.post('/', updateContrato)

    await powerAppsApi.post('/', { acao: 'importar_orcamento', proj_id: this.state.projectState.proj_id }, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Accept: 'multipart/form-data',
      },
    })

    notifySuccess(`Projeto aberto com sucesso.`)
    this.setState({ confirmProjAberturaModalOpen: false });
    this.setState({ projectState: projUpdated.data[0] })
    this.props.getProject(this.state.projectState.proj_id)
  }

  convertNameFieldToDataField = (nameField) => {
    switch (nameField) {
      case 'nome':
        return 'proj_nome'
      case 'situacao':
        return 'projSituacao_id'
      case 'latitude':
        return 'proj_lat'
      case 'longitude':
        return 'proj_lon'
      case 'inicioExecucao':
        return 'proj_dtIniPrev'
      default:
        return nameField
    }
  }

  handleSaveField = async (field) => {
    const { editableProjectData } = this.state
    const { project } = this.props.location

    try {
      const update = {
        action: 'update',
        table: 'proj',
        data: {
          proj_id: this.state.projectState.proj_id,
          [this.convertNameFieldToDataField(field)]: editableProjectData[this.convertNameFieldToDataField(field)],
        }
      }

      await oikosApi.post('/', update)
      notifySuccess(`Campo ${field} salvo com sucesso.`)
      this.props.getProject(this.state.projectState.proj_id)
      this.toggleEditField(field, false)
    } catch (e) {
      notifyError(`Erro ao salvar ${field}`)
      console.log(e)
    }
  }

  handleSaveReviewedTabs = async (tabName) => {
    const { projectState } = this.state

    const newReviewedTabs = { ...this.state.reviewedTabs, [tabName]: true }
    this.markReviewed(tabName);

    const update = {
      action: 'update',
      table: 'proj',
      data: {
        proj_id: projectState.proj_id,
        proj_check: JSON.stringify(newReviewedTabs),
      }
    }

    await oikosApi.post('/', update)
    notifySuccess(`Aba revisada.`)
  }

  preloading = async (proj_id) => {
    this.setState({ selTpStatus: await selectValues('prodStatusTp', 'prodStatusTp_id', 'prodStatusTp_nome') });

    const res = await oikosApi.get('/?' + qs.stringify({
      action: 'get',
      table: 'proj',
      data: {
        proj_id: proj_id,
        proj_ativo: 1,
      },
      fields: {
        '(SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_contratante',
        '(SELECT pf_id FROM projEquipe AS pe WHERE pe.proj_id = proj.proj_id AND pe.projAtuacao_id = 8 AND pe.projEquipe_ativo = 1 ORDER BY pe.projEquipe_ini DESC LIMIT 1)': 'pf_id_coordenador',
        "(SELECT c.contrato_prazoVigencia FROM contrato c WHERE c.contrato_original = (SELECT contrato_id FROM contrato WHERE contrato.contrato_id = proj.contrato_id) ORDER BY c.contrato_dtAssin DESC, c.contrato_id DESC LIMIT 1)": "contrato_prazoVigenciaAditivo",
        "(SELECT c.contrato_prazoVigencia FROM contrato c WHERE c.contrato_id = proj.contrato_id LIMIT 1)": "contrato_prazoVigencia",
        "(SELECT c.contrato_dtAssin FROM contrato c WHERE c.contrato_id = proj.contrato_id LIMIT 1)": "contrato_dtAssin",
      }
    }));

    const orcItems = await endPoints1Api.post('/',
      {
        acao: 'get_orcItems_proj',
        proj_id: proj_id
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }
    );

    const propOrcItems = await powerAppsApi.post('/',
      {
        acao: 'get_proporcitems_proj',
        proj_id: proj_id,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }
    )

    if (Number(res.data[0].projSituacao_id) === 0) {
      await insOrUp('proj', { proj_id, projSituacao_id: 1 });
    };

    const additiveContracts = await oikosApi.get('/?' + qs.stringify({
      action: 'get',
      table: 'contrato',
      data: {
        contrato_original: res.data[0].contrato_id,
        contrato_ativo: 1,
      },
      fields: {
        '(SELECT contratoAlterTp_desc FROM contratoAlterTp WHERE contratoAlterTp.contratoAlterTp_id = contrato.contratoAlterTp_id)': 'contratoAlterTp_desc',
      }
    }));
    res.data[0].proj_check = JSON.parse(res.data[0].proj_check);
    console.log({ ...res.data[0], orcItems: orcItems.data, propOrcItems: propOrcItems.data })
    const contrato_id = res.data[0]?.contrato_id
    this.setState({ projectState: { ...res.data[0], orcItems: orcItems.data, propOrcItems: propOrcItems.data }, reviewedTabs: res.data[0].proj_check, additiveContracts: additiveContracts.data });
    if (contrato_id) {
      this.props.getProjectContract(contrato_id)
      this.loadProjSolicitationsAndLetters(contrato_id)
    }
  }

  getDocuments = async () => {
    try {
      this.setState({ getDocumentsisloading: true })
      const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,77161ad8-7adf-4b56-bffe-f28807248097'
      const driveId = 'b!9gc64WoJ7kWN-nT1MrGaf9gaFnffelZLv_7yiAckgJfsjN9l2AUYRKkEAg_fnGU3'
      const itemId = '01RCA2HBJC3QPVYFUB35CIVGBIAXZGPJ7E'
      const endpoint = `sites/${siteId}/drives/${driveId}/items/${itemId}/children?$&top=9999`
      const res = await graphClient.api(endpoint).get()
      console.log('getDocSolicitations data', res)

      this.setState({
        getDocumentsisloading: false,
        documents: res.value,
      })
    } catch (e) {
      notifyError('Erro ao carregar documentos', e.toString())
    }
  }

  getDocumentsOikos = async () => {
    const { addProductData, documentsProducts } = this.state

    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'documentoVinc',
      data: {

        documentoVinc_ativo: 1,
        documentoVinc_tabRef: 'prod',
        documentoVinc_tabId: addProductData.prod_id,

      },
      fields: {
        '(SELECT documento_desc FROM documento WHERE documento.documento_id = documentoVinc.documento_id)': 'documento_desc',
        '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1))': 'tpDocumento_desc',
        '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id)': 'arquivo_caminho',
      },
    })}`)


    this.setState({
      getDocumentsisloading: false,
      documentsProducts: res.data,
    })
    console.log('documentos Oikos do produto', res.data)
  }

  deleteDocuments = async (docId) => {
    const { addDocData } = this.state
    try {
      const deleteDoc = {
        action: 'delete',
        table: 'documento',
        data: {
          documento_id: docId,
        },
      }
      console.log('deleteDoc ', deleteDoc)
      const productDeleted = await oikosApi.post('/', deleteDoc)
      notifySuccess('Documento removido com sucesso.')
      this.props.getProjectProducts(addDocData.proj_id)
    } catch (e) {
      notifyError('Erro ao remover o documento');
      console.log('Não foi possível remover o documento.', e)
    }
    this.setState({ addProductModalIsOpen: false })
  }


  mapStatusCode = status => {
    switch (status) {
      case 'Elaborando': return 2
      case 'Preparando Entrega': return 2
      case 'Atrasado': return 2
      case 'Correção EP': return 2
      case 'Liberado': return 2
      case 'Aprovação Direção': return 2
      case 'Entregue': return 4
      case 'Enviado para Cliente (Digital)': return 3
      case 'Em Revisão 1': return 4
      case 'Em Revisão 2': return 4
      case 'Em Revisão 3': return 4
      case 'Aprovado pelo Cliente': return 5
      default: return 1
    }
  }

  formatProjectStatus = status => {
    switch (status) {
      case 0:
        return <Badge className="badge-soft-info mr-1">Não aberto</Badge>
      case 1:
        return <Badge className="badge-soft-warning mr-1">Em abertura</Badge>
      case 2:
        return <Badge className="badge-soft-warning mr-1">Em andamento</Badge>
      case 3:
        return <Badge className="badge-soft-warning mr-1">Em encerramento</Badge>
      case 4:
        return <Badge className="badge-soft-success mr-1">Concluído</Badge>
      case 5:
        return <Badge className="badge-soft-danger mr-1">Cancelado</Badge>
      case 6:
        return <Badge className="badge-soft-danger mr-1">Suspenso</Badge>
      default:
        return <Badge className="badge-soft mr-1"></Badge>
    }
  }

  handleEditProjectTeamSelectionChange = people => {
    if (people.length > 0) {
      const editProjectTeamPeople = []
      console.log('pessoas: ', people)
      people.map(person => editProjectTeamPeople.push(person.id))
      return this.setState({ editProjectTeamPeople })
    }
    return this.setState({ editProjectTeamPeople: [] })
  }

  handleEditProjectTeam = async () => {
    const { editProjectTeamPeople } = this.state
    const { project } = this.props.location
    const { getProjectTeam } = this.props

    if (editProjectTeamPeople.length > 0 && this.state.projectState) {
      try {
        const res = await powerAppsApi.post('/', {
          acao: 'editar_equipe_projeto_id',
          proj_id: this.state.projectState.proj_id,
          emails: editProjectTeamPeople,
        }, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        console.log('editar_equipe_projeto_id res', res)

        getProjectTeam(this.state.projectState.proj_id)
      } catch (err) {
        notifyError('Erro ao editar equipe do projeto. Tente novamente mais tarde.')
        console.log(err)
      }
    }

    return this.setState({ editProjectTeamDialogIsOpen: false, editProjectTeamPeople: [] })
  }

  openAddProductModal = async (proj_id, orcRubr_id) => {
    let recList = []
    if (orcRubr_id) {
      const recFields = {
        "(SELECT recTp_nome FROM recTp WHERE recTp.recTp_id = rec.recTp_id LIMIT 1)": "recTp_nome",
      }
      const recRaw = await getRegs('rec', { orcRubr_id }, recFields)
      recList = Array.isArray(recRaw) ? recRaw : []
    }
    this.setState({
      addProductModalIsOpen: true,
      addProductData: { proj_id, prodFatFlag_id: 0, rec_id: null },
      recList,
    })
  }

  handleSubmitProduct = async () => {
    const { addProductData } = this.state
    const prodFatFlag_id = Number(addProductData?.prodFatFlag_id) === 1 ? 1 : 0
    const rec_id = addProductData?.rec_id == null || addProductData.rec_id === ''
      ? null
      : Number(addProductData.rec_id)
    if (prodFatFlag_id === 1 && rec_id == null) {
      notifyError('Com faturamento associado, é obrigatório informar um ou mais eventos de faturamento.')
      return
    }
    if (!addProductData.prod_id) {
      // Será necessário criar um novo registro
      try {
        const insertProduct = {
          action: 'insert',
          table: 'prod',
          data: {
            proj_id: addProductData.proj_id,
            prod_num: addProductData?.prod_num || undefined,
            prod_desc: addProductData?.prod_desc,
            prod_avalEP: addProductData?.prod_avalEP || undefined,
            prod_aprovEP: addProductData?.prod_aprovEP || undefined,
            prod_obsEP: addProductData?.prod_obsEP,
            prod_responsavel: addProductData?.prod_responsavel,
            prod_vlr: Number(addProductData?.prod_vlr),
            prod_dtContrato: addProductData.prod_dtContrato ? moment(addProductData.prod_dtContrato).format('YYYY-MM-DD') : undefined,
            prod_dtInterna: addProductData.prod_dtInterna ? moment(addProductData.prod_dtInterna).format('YYYY-MM-DD') : undefined,
            prod_dtEntrega: addProductData.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).format('YYYY-MM-DD') : undefined,
            prod_dtAprov: addProductData.prod_dtAprov ? moment(addProductData.prod_dtAprov).format('YYYY-MM-DD') : undefined,
            prod_dtLimAprov: addProductData.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).format('YYYY-MM-DD') : undefined,
            prodStatusTp_id: addProductData?.prodStatusTp_id,
            prod_formato: addProductData?.prod_formato,
            prodFatFlag_id,
            rec_id: rec_id == null ? undefined : rec_id,
          },
        }
        console.log('insertProduct ', insertProduct)
        const productCreated = await oikosApi.post('/', insertProduct)
        notifySuccess('Produto cadastrado com sucesso.')
        this.props.getProjectProducts(addProductData.proj_id)
      } catch (e) {
        notifyError('Erro ao cadastrar o produto');
        console.log('Não foi possível cadastrar o produto.', e)
      }
    } else {
      // O produto está sendo editado. Basta usar a rota de atualização
      try {
        const updateProduct = {
          action: 'update',
          table: 'prod',
          data: {
            prod_id: addProductData.prod_id,
            proj_id: addProductData.proj_id,
            prod_num: addProductData?.prod_num || undefined,
            prod_desc: addProductData?.prod_desc,
            prod_avalEP: addProductData?.prod_avalEP || undefined,
            prod_aprovEP: addProductData?.prod_aprovEP || undefined,
            prod_obsEP: addProductData?.prod_obsEP,
            prod_responsavel: addProductData?.prod_responsavel,
            prod_vlr: Number(addProductData?.prod_vlr),
            prod_dtContrato: addProductData.prod_dtContrato ? moment(addProductData.prod_dtContrato).format('YYYY-MM-DD') : undefined,
            prod_dtInterna: addProductData.prod_dtInterna ? moment(addProductData.prod_dtInterna).format('YYYY-MM-DD') : undefined,
            prod_dtEntrega: addProductData.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).format('YYYY-MM-DD') : undefined,
            prod_dtAprov: addProductData.prod_dtAprov ? moment(addProductData.prod_dtAprov).format('YYYY-MM-DD') : undefined,
            prod_dtLimAprov: addProductData.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).format('YYYY-MM-DD') : undefined,
            prodStatusTp_id: addProductData?.prodStatusTp_id,
            prod_formato: addProductData?.prod_formato,
            prodFatFlag_id,
            rec_id,
          },
        }
        console.log('updateProduct ', updateProduct)
        const productUpdated = await oikosApi.post('/', updateProduct)
        notifySuccess('Produto atualizado com sucesso.')
        this.props.getProjectProducts(addProductData.proj_id)
      } catch (e) {
        notifyError('Erro ao atualizar o produto');
        console.log('Não foi possível cadastrar o produto.', e)
      }
    }
    this.setState({ addProductModalIsOpen: false })
  }

  handleDeleteProduct = async (prodId) => {
    const { addProductData } = this.state
    try {
      const deleteProduct = {
        action: 'delete',
        table: 'prod',
        data: {
          prod_id: prodId,
        },
      }
      console.log('deleteProduct ', deleteProduct)
      const productDeleted = await oikosApi.post('/', deleteProduct)
      notifySuccess('Produto removido com sucesso.')
      this.props.getProjectProducts(addProductData.proj_id)
    } catch (e) {
      notifyError('Erro ao remover o produto');
      console.log('Não foi possível remover o produto.', e)
    }
    this.setState({ addProductModalIsOpen: false })
  }

  enviarEmail = async (destinatario, assunto, texto, cc) => {
    try {
      const body = {
        acao: 'enviar_email',
        to_mail: destinatario,
        subject: assunto,
        msg: texto,
        attached_files: 'arquivos/f839672af7a133b28e9880190b977018.pdf,arquivos/b6b6a85b024270b8cc39a44dac755ba3.pdf',
        from_name: 'Teste_INSOMNIA',
        to_name: 'Bê',
        reply_mail: cc,
        reply_name: 'Pirata da perna de pau',
      }

      const res = await powerAppsApi.post('/', body, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      })
    }
    catch (err) {
      console.log(err)
    }
  }
  handleAddDocSubmit = async () => {
    try {
      this.setState({ addDocIsLoading: true })

      const { addProductData } = this.state
      const files = this.filesRef?.current?.state?.files
      const prodFinalFile = this.prodFinalFileRef?.current?.state?.files


      if (prodFinalFile.length <= 0) {
        notifyError('É necessário anexar o arquivo do contrato antes de confirmar.')
        return this.setState({ addContractIsLoading: false })
      }

      //cria o registro Produto na tabela documento
      const documentBody = {
        action: 'insert',
        table: 'documento',
        data: {
          tpDocumento_id: 23,
          documento_desc: `Projeto ID ${addProductData.proj_id} - Produto ID ${addProductData.prod_id}`,
          privacidade_id: 2,
        },
      }
      console.log('documentBody', documentBody)
      const documentCreated = await oikosApi.post('/', documentBody)
      console.log('documentCreated', documentCreated)

      //criar vinculação do Produto
      if (documentCreated.data[0].documento_id) {
        const vinculationBody = {
          action: 'insert',
          table: 'documentoVinc',
          data: {
            documento_id: documentCreated.data[0].documento_id,
            documentoVinc_tabRef: 'prod',
            documentoVinc_tabId: addProductData.prod_id,
          },
        }
        console.log('vinculationBody', vinculationBody)
        const vinculationCreated = await oikosApi.post('/', vinculationBody)
        console.log('vinculationCreated', vinculationCreated)
      }

      // Faz upload do Produto final
      if (prodFinalFile.length > 0) {
        const formData = new FormData()
        formData.append('file', new Blob([prodFinalFile[0].data], { type: prodFinalFile[0].data.type }), prodFinalFile[0].data.path)
        formData.append('table', 'arquivo')
        formData.append('action', 'upload_file')
        formData.append('arquivo_tabRef', 'documento')
        formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
        formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
        formData.append('arquivo_desc', prodFinalFile[0].data.path)

        const res = await oikosApi.post('/', formData)
        console.tron.log('res upload_file', res)
      }

      // Faz upload dos anexos gerais
      if (files.length > 0) {
        await Promise.all(files.map(async file => {
          // Cria um registro na tabela de documentos para cada arquivo
          const documentBody = {
            action: 'insert',
            table: 'documento',
            data: {
              tpDocumento_id: file.props?.documentType?.tpDocumento_id,
              documento_desc: `Projeto ID ${addProductData.proj_id} - Produto ID ${addProductData.prod_id} - Descrição ${file.props?.description}`,
              documento_iniVig: undefined,
              documento_fimVig: undefined,
              documento_dtEmissao: undefined,
              documento_prazo: undefined,
              documento_ref: undefined,
              privacidade_id: 2,
            },
          }
          const documentCreated = await oikosApi.post('/', documentBody)

          // Cria uma vinculação entre o documento (anexo) e o Produto
          if (documentCreated.data[0].documento_id) {
            const vinculationBody = {
              action: 'insert',
              table: 'documentoVinc',
              data: {
                documento_id: documentCreated.data[0].documento_id,
                documentoVinc_tabRef: 'prod',
                documentoVinc_tabId: addProductData.prod_id,
              },
            }
            await oikosApi.post('/', vinculationBody)
          }

          // Faz upload dos anexos e registra na tabela 'arquivo'
          const formData = new FormData()
          formData.append('file', new Blob([file.data], { type: file.data.type }), file.data.path)
          formData.append('table', 'arquivo')
          formData.append('action', 'upload_file')
          formData.append('arquivo_tabRef', 'documento')
          formData.append('arquivo_tabId', documentCreated.data[0].documento_id)
          formData.append('arquivo_privacidade', documentCreated.data[0].privacidade_id)
          formData.append('arquivo_desc', file.data.path)
          const fileUploadRes = await oikosApi.post('/', formData)
          console.log('fileUploadRes', fileUploadRes)
        }))
      }


      notifySuccess('Produto Final e Anexos cadastrado com sucesso.')
      this.setState({
        addContractIsLoading: false,
        addProductData: {},
        addPaymentData: {},
      })
    } catch (e) {
      notifyError('Não foi possível cadastrar o Produto Final.')
      console.log('Não foi possível cadastrar o Produto Final.', e)
      this.setState({ addContractIsLoading: false })
    }
  }

  // Modals for project-scoped solicitations/letters
  toggleProjLegalModal = () => {
    this.setState(prevState => ({
      projLegalModalOpen: !prevState.projLegalModalOpen,
      projLegalRequester: !prevState.projLegalModalOpen
        ? (
          this.props.auth?.user?.pf_nome
          || this.props.auth?.user?.pf_nomeExibicao
          || this.props.auth?.user?.displayName
          || prevState.projLegalRequester
          || ''
        )
        : prevState.projLegalRequester,
      projLegalRequesterError: '',
      projLegalSubject: null,
      projLegalSubjectError: '',
      projLegalPriority: null,
      projLegalPriorityError: '',
      projLegalDate: '',
      projLegalDateError: '',
      projLegalDateOpen: false,
      projLegalDescription: EditorState.createEmpty(),
      projLegalDescriptionError: '',
      projLegalFatoGerador: '',
      projLegalAttachment: null,
    }))
  }

  toggleProjReceiveLetterModal = () => {
    if (this.props.postOfficialLetterReceivedIsLoading) return
    this.setState(prevState => {
      const opening = !prevState.projReceiveLetterModalOpen
      return {
        projReceiveLetterModalOpen: opening,
        projReceiveNumero: '',
        projReceiveSender: '',
        projReceiveSenderError: '',
        projReceiveDate: '',
        projReceiveDateError: '',
        projReceiveLetterDate: '',
        projReceiveLetterDateError: '',
        projReceiveSubjectBody: EditorState.createEmpty(),
        projReceiveSubjectBodyError: '',
        projReceiveForwardDepartments: [],
        projReceiveForwardDepartmentsError: '',
        projReceiveCcEmail: '',
        projReceiveTemPrazo: false,
        projReceivePrazo: '',
        projReceiveAttachment: null,
        projReceiveObservations: '',
        projReceiveGerarDemanda: false,
        projReceiveDemandaJuridica: null,
        projReceiveDemandaModalOpen: false,
        projReceiveDemandaDefaults: null,
      }
    })
  }

  // Submits
  handleProjLegalSubmit = () => {
    const { projLegalSubject, projLegalPriority, projLegalDescription, projLegalDate, projLegalAttachment, projLegalRequester, projLegalFatoGerador } = this.state

    let isValid = true
    if (!projLegalSubject) {
      this.setState({ projLegalSubjectError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projLegalPriority) {
      this.setState({ projLegalPriorityError: 'Campo obrigatório.' })
      isValid = false
    }
    const projLegalDescHtml = rawToHtml(projLegalDescription).trim()
    if (!projLegalDescHtml || projLegalDescHtml === '<p></p>') {
      this.setState({ projLegalDescriptionError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projLegalDate) {
      this.setState({ projLegalDateError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projLegalRequester.trim()) {
      this.setState({ projLegalRequesterError: 'Campo obrigatório.' })
      isValid = false
    }

    if (isValid) {
      const newSolicitation = {
        solicitante: projLegalRequester,
        solicitanteExibicao: String(
          this.props.auth?.user?.pf_nomeExibicao
          || this.props.auth?.user?.pf_nome
          || this.props.auth?.user?.displayName
          || ''
        ).trim(),
        tipo_assunto: projLegalSubject.value,
        prioridade: projLegalPriority.value,
        teor: projLegalDescHtml,
        prazo_atendimento: moment(projLegalDate).format('YYYY-MM-DD'),
        fato_gerador: projLegalFatoGerador,
        status: 'Aguardando atendimento',
      }

      if (this.props.technicalDep.projectContract && this.props.technicalDep.projectContract.contrato_id) {
        newSolicitation.contrato_id = this.props.technicalDep.projectContract.contrato_id
      }

      if (projLegalAttachment) {
        newSolicitation.anexo = projLegalAttachment.name
        newSolicitation.anexoFile = projLegalAttachment
      }
      this.props.postLegalSolicitation(newSolicitation)
      this.setState({
        projLegalModalOpen: false,
      })
    }
  }

  handleProjCreateLetterSubmit = () => {
    const {
      projCreateSigner,
      projCreateSubject,
      projCreateDate,
      projCreateRecipient,
      projCreateBody,
      projCreateAttachment,
    } = this.state

    let isValid = true

    if (!projCreateSigner.trim()) {
      this.setState({ projCreateSignerError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projCreateSubject.trim()) {
      this.setState({ projCreateSubjectError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projCreateDate) {
      this.setState({ projCreateDateError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projCreateRecipient.trim()) {
      this.setState({ projCreateRecipientError: 'Campo obrigatório.' })
      isValid = false
    }
    const projCreateBodyHtml = rawToHtml(projCreateBody).trim()
    if (!projCreateBodyHtml || projCreateBodyHtml === '<p></p>') {
      this.setState({ projCreateBodyError: 'Campo obrigatório.' })
      isValid = false
    }

    if (isValid) {
      if (this.state.projCreateGerarDemanda && !this.state.projCreateDemandaJuridica) {
        this.openProjCreateDemandaModal()
        return
      }
      if (this.state.projCreateGerarDemanda && this.getProjCreateFormBlockedDemandId()) {
        return
      }

      const newLetter = {
        numero_oficio: this.state.projCreateNumero.trim() || null,
        data_oficio: moment(projCreateDate).format('YYYY-MM-DD'),
        data_envio: this.state.projCreateSendDate ? moment(this.state.projCreateSendDate).format('YYYY-MM-DD') : null,
        data_recebimento: this.state.projCreateReceiveDate ? moment(this.state.projCreateReceiveDate).format('YYYY-MM-DD') : null,
        responsavel_assinatura: projCreateSigner,
        assunto: projCreateSubject,
        destinatario: projCreateRecipient,
        teor: projCreateBodyHtml,
        anexo: projCreateAttachment ? projCreateAttachment.name : '',
        anexoFile: projCreateAttachment,
        observacoes: this.state.projCreateObservations,
        status: 'Em elaboração',
        gerar_demanda_juridica: this.state.projCreateGerarDemanda,
        demanda_juridica: this.state.projCreateGerarDemanda ? this.state.projCreateDemandaJuridica : null,
        criado_por_pf_id: this.state.userOikosId || this.props.auth.user?.pf_id || null,
        contrato_id: this.props.technicalDep.projectContract?.contrato_id,
      }

      if (this.state.projCreateLinkReceived) {
        newLetter.oficios_recebidos_id = this.state.projCreateLinkReceived.value
      }
      if (this.state.projRespondToReceived) {
        const receivedId = getRowId(this.state.projRespondToReceived, false)
        newLetter.oficio_origem_recebido_id = receivedId
        newLetter.oficios_recebidos_id = receivedId
      }

      this.props.postOfficialLetterCreated(newLetter)
    }
  }

  handleProjReceiveLetterSubmit = () => {
    const {
      projReceiveNumero,
      projReceiveSender,
      projReceiveDate,
      projReceiveLetterDate,
      projReceiveSubjectBody,
      projReceiveForwardDepartments,
      projReceiveAttachment,
      projReceiveTemPrazo,
      projReceivePrazo,
      projReceiveGerarDemanda,
      projReceiveDemandaJuridica,
    } = this.state

    let isValid = true

    if (!projReceiveNumero.trim()) isValid = false
    if (!projReceiveSender.trim()) {
      this.setState({ projReceiveSenderError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projReceiveDate) {
      this.setState({ projReceiveDateError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projReceiveLetterDate) {
      this.setState({ projReceiveLetterDateError: 'Campo obrigatório.' })
      isValid = false
    }
    const projReceiveSubjectBodyHtml = rawToHtml(projReceiveSubjectBody).trim()
    if (!projReceiveSubjectBodyHtml || projReceiveSubjectBodyHtml === '<p></p>') {
      this.setState({ projReceiveSubjectBodyError: 'Campo obrigatório.' })
      isValid = false
    }
    if (!projReceiveForwardDepartments || projReceiveForwardDepartments.length === 0) {
      this.setState({ projReceiveForwardDepartmentsError: 'Campo obrigatório.' })
      isValid = false
    }
    if (projReceiveTemPrazo && !projReceivePrazo) isValid = false

    if (isValid) {
      if (projReceiveGerarDemanda && !projReceiveDemandaJuridica) {
        this.openProjReceiveDemandaModal()
        return
      }

      const selectedDeptNames = projReceiveForwardDepartments.map(d => d.label).join(', ')
      const selectedEmails = projReceiveForwardDepartments.map(d => d.value).join(', ')

      const newLetter = {
        numero_oficio: projReceiveNumero.trim(),
        data_recebimento: moment(projReceiveDate).format('YYYY-MM-DD'),
        data_oficio: moment(projReceiveLetterDate).format('YYYY-MM-DD'),
        remetente: projReceiveSender,
        assunto_teor: projReceiveSubjectBodyHtml,
        encaminhar_para_email: selectedEmails,
        setor_responsavel: selectedDeptNames,
        com_copia_para: this.state.projReceiveCcEmail,
        anexo: projReceiveAttachment ? projReceiveAttachment.name : '',
        anexoFile: projReceiveAttachment,
        observacoes: this.state.projReceiveObservations,
        status: 'Resposta pendente',
        tem_prazo_resposta: projReceiveTemPrazo ? 1 : 0,
        prazo_resposta: projReceiveTemPrazo && projReceivePrazo ? moment(projReceivePrazo).format('YYYY-MM-DD') : null,
        criado_por_pf_id: this.state.userOikosId || this.props.auth.user?.pf_id || null,
        contrato_id: this.props.technicalDep.projectContract?.contrato_id,
        gerar_demanda_juridica: projReceiveGerarDemanda,
        demanda_juridica: projReceiveGerarDemanda ? projReceiveDemandaJuridica : null,
      }

      this.props.postOfficialLetterReceived(newLetter)
    }
  }

  toggleProjLegalDetailsModal = () => {
    this.setState(prevState => ({ projLegalDetailsModalOpen: !prevState.projLegalDetailsModalOpen }))
  }

  openProjAnexo = (e, caminho) => {
    e.preventDefault()
    e.stopPropagation()
    const url = getOikosFileUrl(caminho)
    if (url) window.open(url, '_blank', 'noopener,noreferrer')
  }

  openProjLegalDetailsModal = (solicitation) => {
    const sid = Number(solicitation?.id || solicitation?.solicitacoes_juridicas_id)
    const fromStore = (this.props.legalSolicitations || []).find(
      s => Number(s.id || s.solicitacoes_juridicas_id) === sid
    )
    this.setState({
      projLegalDetailsModalOpen: true,
      projLegalSelected: fromStore || solicitation,
    })
  }

  handleProjLegalResponseSubmit = () => {
    const { projLegalResponseDescription, projLegalResponseAttachment, projLegalSelected } = this.state;

    const descriptionHtml = rawToHtml(projLegalResponseDescription).trim();
    if (!descriptionHtml || descriptionHtml === '<p></p>') {
      this.setState({ projLegalResponseDescriptionError: 'Por favor, escreva uma mensagem.' });
      return;
    }

    const payload = {
      solicitacao_id: projLegalSelected.id || projLegalSelected.solicitacoes_juridicas_id,
      autor_id: this.state.userOikosId,
      teor: descriptionHtml,
      anexo: projLegalResponseAttachment ? projLegalResponseAttachment.name : '',
      anexoFile: projLegalResponseAttachment,
    };

    this.props.postLegalSolicitationResponse(payload);

    // Clear and close
    this.setState({
      projLegalResponseDescription: EditorState.createEmpty(),
      projLegalResponseAttachment: null,
    });

    // We could either close the modal, or keep it open and let it reload responses.
    // Let's close it so they know it sent successfully.
    this.toggleProjLegalDetailsModal();
  }

  getProjContractLabel = () => {
    const { projectContract } = this.props.technicalDep
    const { projectState } = this.state
    if (projectContract) {
      return `${projectContract.pj_razaosocial || projectContract.pj_nomefanta || 'Sem Nome'} — ${projectContract.contrato_num ? `Nº ${projectContract.contrato_num}` : `ID: ${projectContract.contrato_id}`}`
    }
    if (projectState && projectState.contrato_id) {
      return `Contrato ID: ${projectState.contrato_id}`
    }
    return '—'
  }

  getFornecedoresTabIndex = (project) => {
    const user = this.props.auth?.user || {}
    const canSeeFinanceiro = (
      user.perm_id === 1
      || user.pf_id === project?.proj_coord
      || user.pf_id === 104
    )
    // Índices: Visão geral, Produtos, Eventos, Aditivos, [Financeiro], Equipe,
    // Stakeholders, Documentos, Bordero, Fornecedores
    return canSeeFinanceiro ? 9 : 8
  }

  handleOpenContrFornFromOrcItems = (contrFornId, { compraCotacaoId } = {}) => {
    if (!contrFornId) return
    const { project } = this.props.technicalDep
    this.setState((prev) => ({
      selectedProjectTab: this.getFornecedoresTabIndex(project),
      expandContrFornId: Number(contrFornId),
      expandCompraCotacaoId: Number(compraCotacaoId) || null,
      expandContrFornRequestKey: (prev.expandContrFornRequestKey || 0) + 1,
    }))
  }

  formatProjStatusBadge = (status, colorMap) => {
    const color = colorMap[status] || '#aaa'
    return (
      <span style={{
        display: 'inline-block',
        border: `2px solid ${color}`,
        borderRadius: 4,
        padding: '2px 8px',
        fontSize: 11,
        color: color,
        fontWeight: 'bold',
        background: '#fff',
        whiteSpace: 'nowrap',
      }}>
        {status || '—'}
      </span>
    )
  }

  formatProjSolicitationStatus = (row) => {
    const colorMap = {
      'Aguardando atendimento': '#f0ad4e',
      'Em análise pelo jurídico': '#5bc0de',
      'Concluído': '#5cb85c',
    }
    return this.formatProjStatusBadge(row.status, colorMap)
  }

  formatProjCreatedLetterStatus = (row) => this.formatProjStatusBadge(row.status, CREATED_STATUS_COLOR_MAP)

  formatProjReceivedLetterStatus = (row) => this.formatProjStatusBadge(row.status, RECEIVED_STATUS_COLOR_MAP)

  get projContractId() {
    return this.props.technicalDep.projectContract?.contrato_id || this.state.projectState?.contrato_id
  }

  get projCreatedLetters() {
    const cid = this.projContractId
    if (!cid) return []
    const list = Array.isArray(this.props.officialLettersCreated) ? this.props.officialLettersCreated : []
    return list
      .filter(row => String(row.contrato_id) === String(cid))
      .sort((a, b) => Number(getRowId(b, true)) - Number(getRowId(a, true)))
  }

  get projReceivedLetters() {
    const cid = this.projContractId
    if (!cid) return []
    const list = Array.isArray(this.props.officialLettersReceived) ? this.props.officialLettersReceived : []
    return list
      .filter(row => String(row.contrato_id) === String(cid))
      .sort((a, b) => Number(getRowId(b, false)) - Number(getRowId(a, false)))
  }

  get projLegalSolicitations() {
    const cid = this.projContractId
    if (!cid) return []
    const list = Array.isArray(this.props.legalSolicitations) ? this.props.legalSolicitations : []
    return list.filter(row => String(row.contrato_id) === String(cid))
  }

  get currentPfId() {
    return Number(this.state.userOikosId || this.props.auth?.user?.pf_id) || 0
  }

  getReceivedLabel = (id) => {
    const row = this.projReceivedLetters.find(r => Number(getRowId(r, false)) === Number(id))
    if (!row) return `ID ${id}`
    const num = row.numero_oficio ? `${row.numero_oficio} — ` : ''
    return `${num}${row.remetente || 'Sem remetente'}`
  }

  getCreatedLabel = (id) => {
    const row = this.projCreatedLetters.find(r => Number(getRowId(r, true)) === Number(id))
    if (!row) return `ID ${id}`
    const num = row.numero_oficio ? `${row.numero_oficio} — ` : ''
    return `${num}${row.assunto || 'Sem assunto'}`
  }

  getOficioNumberBySolicitacao = (solicitacaoId) => {
    if (!solicitacaoId) return null
    const created = this.projCreatedLetters.find(
      o => Number(o.solicitacoes_juridicas_id) === Number(solicitacaoId)
    )
    if (created) return created.numero_oficio || `#${getRowId(created, true)}`
    const received = this.projReceivedLetters.find(
      o => Number(o.solicitacoes_juridicas_id) === Number(solicitacaoId)
    )
    if (received) {
      const num = received.numero_oficio || `#${getRowId(received, false)}`
      return `${num} (recebido)`
    }
    return null
  }

  getProjCreateFormBlockedDemandId = () => {
    if (this.state.projRespondToReceived?.solicitacoes_juridicas_id) {
      return this.state.projRespondToReceived.solicitacoes_juridicas_id
    }
    const linkedId = this.state.projCreateLinkReceived?.value
      || (this.state.projRespondToReceived ? getRowId(this.state.projRespondToReceived, false) : null)
    if (!linkedId) return null
    const received = this.projReceivedLetters.find(r => Number(getRowId(r, false)) === Number(linkedId))
    return received?.solicitacoes_juridicas_id || null
  }

  getEffectiveCreatedDemandId = (createdRow) => {
    if (createdRow?.solicitacoes_juridicas_id) return createdRow.solicitacoes_juridicas_id
    const receivedId = createdRow?.oficio_origem_recebido_id || createdRow?.oficios_recebidos_id
    if (!receivedId) return null
    const received = this.projReceivedLetters.find(r => Number(getRowId(r, false)) === Number(receivedId))
    return received?.solicitacoes_juridicas_id || null
  }

  getEffectiveReceivedDemandId = (receivedRow) => {
    if (receivedRow?.solicitacoes_juridicas_id) return receivedRow.solicitacoes_juridicas_id
    if (!receivedRow?.oficios_criados_resposta_id) return null
    const created = this.projCreatedLetters.find(
      c => Number(getRowId(c, true)) === Number(receivedRow.oficios_criados_resposta_id)
    )
    return created?.solicitacoes_juridicas_id || null
  }

  canEditRecord = (row) => {
    const creator = Number(row.criado_por_pf_id)
    if (!creator) return true
    return creator === this.currentPfId
  }

  parseForwardDepartments = (emailsStr, labelsStr) => {
    if (!emailsStr) return []
    const emails = String(emailsStr).split(',').map(s => s.trim()).filter(Boolean)
    const labels = labelsStr ? String(labelsStr).split(',').map(s => s.trim()) : []
    return emails.map((email, i) => {
      const fromOptions = PROJECT_FORWARD_EMAIL_OPTIONS.find(o => o.value === email)
        || GERENCIA_EMAIL_OPTIONS.find(o => o.value === email)
      return fromOptions || { value: email, label: labels[i] || email }
    })
  }

  openProjCreateDemandaModal = () => {
    const teorOficio = rawToHtml(this.state.projCreateBody).trim()
    const defaults = buildLegalDemandDefaults({
      solicitante: this.state.projCreateSigner,
      assunto: this.state.projCreateSubject,
      numeroOficio: this.state.projCreateNumero,
      dataOficio: this.state.projCreateDate || null,
      teor: teorOficio !== '<p></p>' ? teorOficio : '',
    })
    if (this.state.projCreateDemandaJuridica) {
      Object.assign(defaults, this.state.projCreateDemandaJuridica)
      defaults.prazo_atendimento = this.state.projCreateDemandaJuridica.prazo_atendimento
        ? moment(this.state.projCreateDemandaJuridica.prazo_atendimento).toDate()
        : defaults.prazo_atendimento
    }
    this.setState({ projCreateDemandaModalOpen: true, projCreateDemandaDefaults: defaults })
  }

  closeProjCreateDemandaModal = (revertCheckbox = true) => {
    this.setState(prev => ({
      projCreateDemandaModalOpen: false,
      projCreateGerarDemanda: revertCheckbox && !prev.projCreateDemandaJuridica ? false : prev.projCreateGerarDemanda,
    }))
  }

  handleProjCreateDemandaConfirm = (demandaJuridica) => {
    this.setState({
      projCreateDemandaJuridica: demandaJuridica,
      projCreateGerarDemanda: true,
      projCreateDemandaModalOpen: false,
    })
  }

  handleProjCreateGerarDemandaChange = (e) => {
    const checked = e.target.checked
    if (checked && this.getProjCreateFormBlockedDemandId()) return
    if (checked) {
      this.setState({ projCreateGerarDemanda: true }, this.openProjCreateDemandaModal)
    } else {
      this.setState({ projCreateGerarDemanda: false, projCreateDemandaJuridica: null })
    }
  }

  openProjTableDemandaModal = (row) => {
    const defaults = buildLegalDemandDefaults({
      solicitante: row.responsavel_assinatura,
      assunto: row.assunto,
      numeroOficio: row.numero_oficio,
      dataOficio: row.data_oficio ? moment(row.data_oficio).toDate() : null,
      teor: row.teor || '',
    })
    this.setState({
      projTableDemandaModalOpen: true,
      projTableDemandaRow: row,
      projTableDemandaDefaults: defaults,
    })
  }

  closeProjTableDemandaModal = () => {
    this.setState({ projTableDemandaModalOpen: false, projTableDemandaRow: null })
  }

  handleProjTableDemandaConfirm = (demandaJuridica) => {
    const { projTableDemandaRow } = this.state
    if (!projTableDemandaRow) return
    const contrato_id = projTableDemandaRow.contrato_id
      || this.props.technicalDep.projectContract?.contrato_id
      || this.state.projectState?.contrato_id
    this.props.generateLegalDemandForOficio({
      row: projTableDemandaRow,
      demanda_juridica: demandaJuridica,
      contrato_id,
      source: 'created',
    })
    this.setState({ projTableDemandaModalOpen: false, projTableDemandaRow: null })
  }

  openProjReceiveDemandaModal = () => {
    const teorOficio = rawToHtml(this.state.projReceiveSubjectBody).trim()
    const defaults = buildLegalDemandDefaults({
      solicitante: this.props.auth?.user?.pf_nomeExibicao || this.props.auth?.user?.pf_nome || '',
      assunto: '',
      numeroOficio: this.state.projReceiveNumero,
      dataOficio: this.state.projReceivePrazo || this.state.projReceiveLetterDate || null,
      teor: teorOficio !== '<p></p>' ? teorOficio : '',
    })
    if (this.state.projReceiveNumero) {
      defaults.fato_gerador = `Ofício recebido ${this.state.projReceiveNumero}`
    }
    if (this.state.projReceiveDemandaJuridica) {
      Object.assign(defaults, this.state.projReceiveDemandaJuridica)
      defaults.prazo_atendimento = this.state.projReceiveDemandaJuridica.prazo_atendimento
        ? moment(this.state.projReceiveDemandaJuridica.prazo_atendimento).toDate()
        : defaults.prazo_atendimento
    }
    this.setState({ projReceiveDemandaModalOpen: true, projReceiveDemandaDefaults: defaults })
  }

  closeProjReceiveDemandaModal = (revertCheckbox = true) => {
    this.setState(prev => ({
      projReceiveDemandaModalOpen: false,
      projReceiveGerarDemanda: revertCheckbox && !prev.projReceiveDemandaJuridica ? false : prev.projReceiveGerarDemanda,
    }))
  }

  handleProjReceiveDemandaConfirm = (demandaJuridica) => {
    this.setState({
      projReceiveDemandaJuridica: demandaJuridica,
      projReceiveGerarDemanda: true,
      projReceiveDemandaModalOpen: false,
    })
  }

  handleProjReceiveGerarDemandaChange = (e) => {
    const checked = e.target.checked
    if (checked) {
      this.setState({ projReceiveGerarDemanda: true }, this.openProjReceiveDemandaModal)
    } else {
      this.setState({ projReceiveGerarDemanda: false, projReceiveDemandaJuridica: null })
    }
  }

  openProjTableReceivedDemandaModal = (row) => {
    const defaults = buildLegalDemandDefaults({
      solicitante: this.props.auth?.user?.pf_nomeExibicao || this.props.auth?.user?.pf_nome || '',
      assunto: '',
      numeroOficio: row.numero_oficio,
      dataOficio: row.prazo_resposta
        ? moment(row.prazo_resposta).toDate()
        : (row.data_oficio ? moment(row.data_oficio).toDate() : null),
      teor: row.assunto_teor || '',
    })
    if (row.numero_oficio) {
      defaults.fato_gerador = `Ofício recebido ${row.numero_oficio}`
    }
    this.setState({
      projTableReceivedDemandaModalOpen: true,
      projTableReceivedDemandaRow: row,
      projTableReceivedDemandaDefaults: defaults,
    })
  }

  closeProjTableReceivedDemandaModal = () => {
    this.setState({ projTableReceivedDemandaModalOpen: false, projTableReceivedDemandaRow: null })
  }

  handleProjTableReceivedDemandaConfirm = (demandaJuridica) => {
    const { projTableReceivedDemandaRow } = this.state
    if (!projTableReceivedDemandaRow) return
    const contrato_id = projTableReceivedDemandaRow.contrato_id
      || this.props.technicalDep.projectContract?.contrato_id
      || this.state.projectState?.contrato_id
    this.props.generateLegalDemandForOficio({
      row: projTableReceivedDemandaRow,
      demanda_juridica: demandaJuridica,
      contrato_id,
      source: 'received',
    })
    this.setState({ projTableReceivedDemandaModalOpen: false, projTableReceivedDemandaRow: null })
  }

  resetProjCreateLetterForm = (extra = {}) => ({
    projCreateLetterModalOpen: false,
    projRespondToReceived: null,
    projCreateNumero: '',
    projCreateSigner: '',
    projCreateSignerError: '',
    projCreateSubject: '',
    projCreateSubjectError: '',
    projCreateDate: '',
    projCreateDateError: '',
    projCreateSendDate: '',
    projCreateReceiveDate: '',
    projCreateRecipient: '',
    projCreateRecipientError: '',
    projCreateBody: EditorState.createEmpty(),
    projCreateBodyError: '',
    projCreateAttachment: null,
    projCreateObservations: '',
    projCreateGerarDemanda: false,
    projCreateDemandaJuridica: null,
    projCreateDemandaModalOpen: false,
    projCreateDemandaDefaults: null,
    ...extra,
  })

  toggleProjCreateLetterModal = () => {
    if (this.props.postOfficialLetterCreatedIsLoading) return
    this.setState(prevState => {
      if (prevState.projCreateLetterModalOpen) return this.resetProjCreateLetterForm()
      return {
        ...this.resetProjCreateLetterForm(),
        projCreateLetterModalOpen: true,
        projCreateNumero: getNextOficioNumber(this.projCreatedLetters),
      }
    })
  }

  openProjRespondModal = (receivedRow) => {
    const numero = getNextOficioNumber(this.projCreatedLetters)
    const subjectPrefix = receivedRow.numero_oficio
      ? `Resposta ao ofício ${receivedRow.numero_oficio}`
      : `Resposta ao ofício recebido #${getRowId(receivedRow, false)}`
    this.setState({
      projCreateLetterModalOpen: true,
      projRespondToReceived: receivedRow,
      projCreateNumero: numero,
      projCreateSubject: subjectPrefix,
      projCreateRecipient: receivedRow.remetente || '',
      projCreateObservations: `Em resposta ao ofício recebido de ${receivedRow.remetente || '—'}.`,
      projCreateLinkReceived: null,
    })
  }

  openProjEditCreatedModal = (row) => {
    if (!this.canEditRecord(row)) return
    this.setState({
      projEditCreatedModalIsOpen: true,
      projEditingCreatedRow: row,
      projEditCreatedNumero: row.numero_oficio || '',
      projEditCreatedStatus: row.status || 'Em elaboração',
      projEditCreatedSigner: row.responsavel_assinatura || '',
      projEditCreatedSubject: row.assunto || '',
      projEditCreatedDate: parseDate(row.data_oficio),
      projEditCreatedSendDate: parseDate(row.data_envio),
      projEditCreatedReceiveDate: parseDate(row.data_recebimento),
      projEditCreatedRecipient: row.destinatario || '',
      projEditCreatedBody: htmlToEditorState(row.teor),
      projEditCreatedObservations: row.observacoes || '',
      projEditCreatedLinkReceived: row.oficios_recebidos_id
        ? { value: row.oficios_recebidos_id, label: this.getReceivedLabel(row.oficios_recebidos_id) }
        : null,
    })
  }

  closeProjEditCreatedModal = () => {
    this.setState({ projEditCreatedModalIsOpen: false, projEditingCreatedRow: null })
  }

  openProjEditReceivedModal = (row) => {
    if (!this.canEditRecord(row)) return
    this.setState({
      projEditReceivedModalIsOpen: true,
      projEditingReceivedRow: row,
      projEditReceivedNumero: row.numero_oficio || '',
      projEditReceivedSender: row.remetente || '',
      projEditReceivedDate: parseDate(row.data_recebimento),
      projEditReceivedLetterDate: parseDate(row.data_oficio),
      projEditReceivedSubjectBody: htmlToEditorState(row.assunto_teor),
      projEditReceivedCcEmail: row.com_copia_para || '',
      projEditReceivedObservations: row.observacoes || '',
      projEditReceivedTemPrazo: !!row.tem_prazo_resposta,
      projEditReceivedPrazo: parseDate(row.prazo_resposta),
    })
  }

  closeProjEditReceivedModal = () => {
    this.setState({ projEditReceivedModalIsOpen: false, projEditingReceivedRow: null })
  }

  handleProjEditCreatedSubmit = () => {
    const { projEditingCreatedRow } = this.state
    if (!projEditingCreatedRow || !this.canEditRecord(projEditingCreatedRow)) return

    const bodyHtml = rawToHtml(this.state.projEditCreatedBody).trim()
    if (!this.state.projEditCreatedNumero.trim() || !bodyHtml || bodyHtml === '<p></p>') return

    this.props.updateOfficialLetter({
      table: 'oficios_criados',
      idField: 'oficios_criados_id',
      idValue: getRowId(projEditingCreatedRow, true),
      contrato_id: this.projContractId,
      data: {
        numero_oficio: this.state.projEditCreatedNumero.trim(),
        status: this.state.projEditCreatedStatus,
        responsavel_assinatura: this.state.projEditCreatedSigner,
        assunto: this.state.projEditCreatedSubject,
        destinatario: this.state.projEditCreatedRecipient,
        data_oficio: this.state.projEditCreatedDate ? moment(this.state.projEditCreatedDate).format('YYYY-MM-DD') : null,
        data_envio: this.state.projEditCreatedSendDate ? moment(this.state.projEditCreatedSendDate).format('YYYY-MM-DD') : null,
        data_recebimento: this.state.projEditCreatedReceiveDate ? moment(this.state.projEditCreatedReceiveDate).format('YYYY-MM-DD') : null,
        teor: bodyHtml,
        observacoes: this.state.projEditCreatedObservations,
        oficios_recebidos_id: this.state.projEditCreatedLinkReceived?.value || null,
      },
    })
    this.closeProjEditCreatedModal()
  }

  handleProjEditReceivedSubmit = () => {
    const { projEditingReceivedRow } = this.state
    if (!projEditingReceivedRow || !this.canEditRecord(projEditingReceivedRow)) return

    const bodyHtml = rawToHtml(this.state.projEditReceivedSubjectBody).trim()
    if (!this.state.projEditReceivedNumero.trim() || !bodyHtml || bodyHtml === '<p></p>') return
    if (this.state.projEditReceivedTemPrazo && !this.state.projEditReceivedPrazo) return

    this.props.updateOfficialLetter({
      table: 'oficios_recebidos',
      idField: 'oficios_recebidos_id',
      idValue: getRowId(projEditingReceivedRow, false),
      contrato_id: this.projContractId,
      data: {
        numero_oficio: this.state.projEditReceivedNumero.trim(),
        remetente: this.state.projEditReceivedSender,
        data_recebimento: this.state.projEditReceivedDate ? moment(this.state.projEditReceivedDate).format('YYYY-MM-DD') : null,
        data_oficio: this.state.projEditReceivedLetterDate ? moment(this.state.projEditReceivedLetterDate).format('YYYY-MM-DD') : null,
        assunto_teor: bodyHtml,
        observacoes: this.state.projEditReceivedObservations,
        tem_prazo_resposta: this.state.projEditReceivedTemPrazo ? 1 : 0,
        prazo_resposta: this.state.projEditReceivedTemPrazo && this.state.projEditReceivedPrazo
          ? moment(this.state.projEditReceivedPrazo).format('YYYY-MM-DD')
          : null,
      },
    })
    this.closeProjEditReceivedModal()
  }


  render() {

    const {
      project, getProjectIsLoading,
      getProjectProductsIsLoading, projectProducts,
      projectTeam, getProjectTeamIsLoading,
      getTeamIsLoading, aval, getAvalIsLoading, aprov, getAprovIsLoading,
    } = this.props.technicalDep

    const { user } = this.props.auth


    {/*const { isManager } = this.props.auth.user*/ }
    const isManager = true;
    if (!isManager) return <Redirect to="/" />



    /* console.log('aval = ', aval)
    console.log('project = ', project)
    console.log('projectTeam = ', projectTeam)
    console.log(this.props) */

    const {
      addProductModalIsOpen, addProductData, recList, addDocumentModalIsOpen, addMailModalIsOpen,
      editProjectTeamDialogIsOpen, editProjectTeamPeople, getDocumentsIsLoading, documents, getDocuments,
      emailData, documentsOikos, documentsProducts, selTpStatus, projectState,

      projActiveSubTab,
      projMarketingSubTab,
      projLegalModalOpen,
      projCreateLetterModalOpen,
      projReceiveLetterModalOpen,

      projLegalRequester,
      projLegalRequesterError,
      projLegalSubject,
      projLegalSubjectError,
      projLegalPriority,
      projLegalPriorityError,
      projLegalFatoGerador,
      projLegalDate,
      projLegalDateError,
      projLegalDateOpen,
      projLegalDescription,
      projLegalDescriptionError,
      projLegalAttachment,

      projCreateNumero,
      projCreateSigner,
      projCreateSignerError,
      projCreateSubject,
      projCreateSubjectError,
      projCreateDate,
      projCreateDateError,
      projCreateSendDate,
      projCreateReceiveDate,
      projCreateRecipient,
      projCreateRecipientError,
      projCreateBody,
      projCreateBodyError,
      projCreateAttachment,
      projCreateObservations,
      projCreateGerarDemanda,
      projCreateDemandaJuridica,
      projCreateDemandaModalOpen,
      projCreateLinkReceived,
      projRespondToReceived,

      projEditCreatedModalIsOpen,
      projEditCreatedNumero,
      projEditCreatedStatus,
      projEditCreatedSigner,
      projEditCreatedSubject,
      projEditCreatedDate,
      projEditCreatedSendDate,
      projEditCreatedReceiveDate,
      projEditCreatedRecipient,
      projEditCreatedBody,
      projEditCreatedObservations,
      projEditCreatedLinkReceived,

      projEditReceivedModalIsOpen,
      projEditingReceivedRow,
      projEditReceivedNumero,
      projEditReceivedSender,
      projEditReceivedDate,
      projEditReceivedLetterDate,
      projEditReceivedSubjectBody,
      projEditReceivedObservations,
      projEditReceivedTemPrazo,
      projEditReceivedPrazo,

      projReceiveNumero,
      projReceiveSender,
      projReceiveSenderError,
      projReceiveDate,
      projReceiveDateError,
      projReceiveLetterDate,
      projReceiveLetterDateError,
      projReceiveSubjectBody,
      projReceiveSubjectBodyError,
      projReceiveForwardDepartments,
      projReceiveForwardDepartmentsError,
      projReceiveCcEmail,
      projReceiveTemPrazo,
      projReceivePrazo,
      projReceiveAttachment,
      projReceiveObservations,
      projReceiveGerarDemanda,
      projReceiveDemandaJuridica,
      projReceiveDemandaModalOpen,

      projLegalList,
      projCreatedLettersList,
      projReceivedLettersList,
      pfOptions,
      projLegalDetailsModalOpen,
      projLegalSelected,
      projLegalResponseDescription,
      projLegalResponseDescriptionError,
      projLegalResponseAttachment,
    } = this.state

    if (getProjectIsLoading || getProjectProductsIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getProjectIsLoading && !getProjectTeamIsLoading && project && aval && aprov && projectTeam) {

      return (

        <><div className="page-content">
          <Container fluid >
            {project.projSituacao_id <= 1 && this.state.allTrue && <Button
              color="primary"
              size="md"
              type="button"
              className='mt-4'
              onClick={() => this.handleOpenProject()}
            >
              Abrir Projeto
            </Button>}
            <Row className="mt-2">
              <Col>
                { }
                {(project.projSituacao_id <= 1) && (this.state.isEditing.nome ? (
                  <div className="d-flex align-items-center">
                    <Input
                      value={this.state.editableProjectData.proj_nome || project.proj_nome}
                      onChange={(e) => this.handleEditableChange('proj_nome', e.target.value)}
                    />
                    <Button color="success" size="sm" onClick={() => this.handleSaveField('nome')} className="ml-2"><CheckIcon /></Button>
                    <Button color="danger" size="sm" onClick={() => this.toggleEditField('nome', false)} className="ml-1"><CloseIcon /></Button>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0">{project.proj_nome}</h3>
                    <Button color="black" size="sm" onClick={() => this.toggleEditField('nome', true)} className="ml-2"><Edit /></Button>
                  </div>
                ))}
                {(project.projSituacao_id > 1) &&
                  <div className="d-flex align-items-center">
                    <h3 className="mb-0">{project.proj_nome}</h3>
                  </div>
                }
                <Row className="mt-2 flex-grow-1">
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Status
                    </span>
                    {
                      this.state.isEditing.situacao ? (
                        <div className='d-flex align-items-center'>
                          <div style={{ minWidth: '180px' }}>
                            <Select
                              value={this.state.selOptionsStatus && this.state.selOptionsStatus.filter(opt => opt.value === this.state.editableProjectData.projSituacao_id)}
                              options={this.state.selOptionsStatus}
                              onChange={(opt) => this.handleEditableChange('projSituacao_id', opt.value)}
                            />
                          </div>
                          <Button color="success" size="sm" onClick={() => this.handleSaveField('situacao')} className="ml-2"><CheckIcon /></Button>
                          <Button color="danger" size="sm" onClick={() => this.toggleEditField('situacao', false)} className="ml-1"><CloseIcon /></Button>
                        </div>
                      ) : (
                        <div className='d-flex align-items-center'>
                          {this.formatProjectStatus(Number(project.projSituacao_id))}
                          {Number(this.state.userOikosId) > 0 && Number(this.state.userOikosId) <= 3 && (
                            <Button color="link" size="sm" onClick={() => {
                              this.setState(prev => ({
                                editableProjectData: {
                                  ...prev.editableProjectData,
                                  projSituacao_id: Number(project.projSituacao_id),
                                },
                              }))
                              this.toggleEditField('situacao', true)
                            }} className="ml-2"><Edit style={{ fontSize: 18 }} /></Button>
                          )}
                        </div>
                      )
                    }
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Cliente
                    </span>
                    <span>
                      {project.pj_nomeFanta}
                    </span>
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Segmento
                    </span>
                    <span>
                      {project.areaAtua_id}
                    </span>
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Equipe
                    </span>
                    <div className="d-flex mt-1">
                      {projectTeam?.length > 0 && (
                        <People
                          showMax={10}
                          peopleQueries={projectTeam.map(person => person.email)} />
                      )}
                    </div>

                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Tabs
                  selectedIndex={this.state.selectedProjectTab}
                  onSelect={(index) => this.setState({ selectedProjectTab: index })}
                >
                  <TabList>
                    <Tab>Visão geral {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.visao_geral ? <span role="img" aria-label="reviewed" ><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab onClick={async () => {
                      const pageContent = await document.querySelector('.page-content');

                      const containerFluid = document.querySelector('.page-content .container-fluid');

                      containerFluid.style.maxWidth = "100%";

                      pageContent.style.paddingLeft = "0px";
                      pageContent.style.paddingRight = "0px";
                    }}>Produtos {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.produtos ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab>Eventos de pagamento {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.eventos_de_pagamento ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab>Aditivos</Tab>
                    {(this.props.auth.user.perm_id === 1 || this.props.auth.user.pf_id === project.proj_coord || this.props.auth.user.pf_id === 104) &&
                      <Tab>Financeiro</Tab>
                    }
                    <Tab>Equipe {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.equipe ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab
                      onClick={() => this.setState({ stakeProjRefreshAt: Date.now() })}
                    >
                      Stakeholders {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.stakeholders ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}
                    </Tab>
                    <Tab>Documentos{(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.documentos ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab>Bordero {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.bordero ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab>Fornecedores {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.bordero ? <span role="img" aria-label="reviewed"><CheckIcon style={{ color: "green" }} /></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{ color: "#DBD050" }} /></span>)}</Tab>
                    <Tab>Equipamentos</Tab>
                    <Tab>Logística</Tab>
                    <Tab>Despesas Gerais</Tab>
                    <Tab>Solicitações</Tab>
                    <Tab>Marketing</Tab>
                    <Tab>Coleta de Dados</Tab>
                    {/*]
                    <Tab>Check list {this.state.reviewedTabs[7] ? <span role="img" aria-label="reviewed"><CheckIcon style={{color: "green"}}/></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{color: "#DBD050"}} /></span>)}</Tab>
                    <Tab>Vagas</Tab>
                    <Tab>Subcontratados {(project.projSituacao_id <= 1) && (this.state.reviewedTabs?.bordero ? <span role="img" aria-label="reviewed"><CheckIcon style={{color: "green"}}/></span> : <span role="img" aria-label="not reviewed"><PriorityHighIcon style={{color: "#DBD050"}} /></span>)}</Tab>
                    */}
                  </TabList>

                  <TabPanel>

                    <div className='d-flex align-items-center justify-content-between'>
                      <div className='d-flex align-items-center'>
                        <span className='mr-5'>Coordenadas</span>
                        {(this.state.isEditing.latitude ? (
                          <div className="d-flex align-items-center mb-3" style={{ width: 'fit-content' }}>
                            <span className='mr-4'>Latitude</span>
                            <Input
                              type='number'
                              value={this.state.editableProjectData.proj_lat || project.proj_lat}
                              onChange={(e) => this.handleEditableChange('proj_lat', e.target.value)}
                            />
                            <Button color="success" size="sm" onClick={() => this.handleSaveField('latitude')} className="ml-2"><CheckIcon /></Button>
                            <Button color="danger" size="sm" onClick={() => this.toggleEditField('latitude', false)} className="ml-1"><CloseIcon /></Button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <span className="">Latitude: {project.proj_lat}</span>
                            <Button color="black" size="sm" onClick={() => this.toggleEditField('latitude', true)} className="ml-2"><Edit /></Button>
                          </div>
                        ))}

                        {(this.state.isEditing.longitude ? (
                          <div className="d-flex align-items-center mb-3" style={{ width: 'fit-content' }}>
                            <span className='mr-4'>Longitude</span>
                            <Input
                              type='number'
                              value={this.state.editableProjectData.proj_lon || project.proj_lon}
                              onChange={(e) => this.handleEditableChange('proj_lon', e.target.value)}
                            />
                            <Button color="success" size="sm" onClick={() => this.handleSaveField('longitude')} className="ml-2"><CheckIcon /></Button>
                            <Button color="danger" size="sm" onClick={() => this.toggleEditField('longitude', false)} className="ml-1"><CloseIcon /></Button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <span className="mb-0">Longitude: {project.proj_lon}</span>
                            <Button color="black" size="sm" onClick={() => this.toggleEditField('longitude', true)} className="ml-2"><Edit /></Button>
                          </div>
                        ))}
                      </div>
                      <div className='d-flex align-items-center ml-4'>
                        <span className='mr-5'>Data de Início da Execução:</span>
                        {(this.state.isEditing.inicioExecucao ? (
                          <div className="d-flex align-items-center" style={{ width: 'fit-content' }}>
                            <Input
                              type='date'
                              value={this.state.editableProjectData.proj_dtIniPrev || project.proj_dtIniPrev}
                              onChange={(e) => { this.handleEditableChange('proj_dtIniPrev', e.target.value); console.log(e.target.value) }}
                            />
                            <Button color="success" size="sm" onClick={() => this.handleSaveField('inicioExecucao')} className="ml-2"><CheckIcon /></Button>
                            <Button color="danger" size="sm" onClick={() => this.toggleEditField('inicioExecucao', false)} className="ml-1"><CloseIcon /></Button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center">
                            <span className='mr-4'>{project.proj_dtIniPrev ? moment(project.proj_dtIniPrev).format('DD/MM/YYYY') : 'Sem data definida'}</span>
                            <Button color="black" size="sm" onClick={() => this.toggleEditField('inicioExecucao', true)} className="ml-2"><Edit /></Button>
                          </div>
                        ))}
                      </div>
                    </div>

                    <Row>
                      <Col>
                        <Card className='mt-4'>
                          <CardHeader>
                            Objeto
                          </CardHeader>
                          <CardBody>
                            {project.contrato_obj}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Card>
                          <CardHeader>
                            <div className='d-flex justify-content-between'>
                              Contrato
                              <a
                                href={`${process.env.REACT_APP_URL || 'https://oikoslab.ecoss.is/oikos-client/'}comercial/contratos/${project.contrato_id}`}
                                target='_blank'
                              >
                                Acessar Contrato
                              </a>
                            </div>
                          </CardHeader>
                          <CardBody>
                            <Table responsive bordered>
                              <tbody>
                                <tr>
                                  <th style={{ width: "200px" }}>Número</th>
                                  <td>{project.contrato_num}</td>
                                </tr>
                                <tr>
                                  <th>Data de assinatura</th>
                                  <td>{project.contrato_dtAssin ? moment(project.contrato_dtAssin).format('DD/MM/YYYY') : null}</td>
                                </tr>
                                <tr>
                                  <th>Vigência Consolidada</th>
                                  <td>
                                    {project.contrato_prazoVigenciaAditivo && moment(project.contrato_prazoVigenciaAditivo).format('DD/MM/YYYY') !== moment(project.contrato_prazoVigencia).format('DD/MM/YYYY')
                                      ? moment(project.contrato_prazoVigenciaAditivo).format('DD/MM/YYYY')
                                      : (project.contrato_prazoVigencia ? moment(project.contrato_prazoVigencia).format('DD/MM/YYYY') : '-')}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Valor consolidado</th>
                                  <td>
                                    {currencyFormatter.format(
                                      (Number(project.contrato_vlrGlobal) || 0) +
                                      (this.state.additiveContracts ? this.state.additiveContracts.reduce((acc, curr) => acc + (Number(curr.contrato_vlrGlobal) || 0), 0) : 0)
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <th>Observações</th>
                                  <td>{project.contrato_obs}</td>
                                </tr>
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    {project?.fields?.GeoLoc?.latitude && false && project?.fields?.GeoLoc?.longitude && (
                      <Row>
                        <Col>
                          <Card>
                            <CardHeader>
                              Localização
                            </CardHeader>
                            <CardBody style={{ width: '100%', height: 400 }}>
                              <p style={{ height: 20 }}>
                                {`${project.fields.City}, ${project.fields.State}, ${project.fields.CountryOrRegion}`}
                              </p>
                              <MapContainer
                                zoom={10}
                                center={[project.fields.GeoLoc.latitude, project.fields.GeoLoc.longitude]}
                                style={{
                                  width: '100%',
                                  height: 'calc(100% - 34px)',
                                }}
                              >
                                <TileLayer
                                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
                                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                                <Marker
                                  position={[project.fields.GeoLoc.latitude, project.fields.GeoLoc.longitude]} />
                              </MapContainer>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    )}
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => {
                        this.handleSaveReviewedTabs('visao_geral');
                      }}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>

                    {getProjectProductsIsLoading && (
                      <Row className="mt-2">
                        <Col className="d-flex justify-content-center">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}
                    {!getProjectProductsIsLoading && projectProducts && (
                      <>
                        <Button
                          size="sm"
                          color="link"
                          className="mb-1 ml-1 px-0"
                          onClick={() => this.openAddProductModal(project.proj_id, project.orcRubr_id)}
                        >
                          Adicionar produto
                        </Button>

                        {/*
                                              BOTAO DE EXCLUIR QUE ESTAVA NA TIMELINE DO OIKOS ANTIGO
                                              <Button
                                              title="Excluir"
                                                className="ml-2"
                                                color="light"
                                                size="sm"
                                                onClick={() => {
                                                  this.setState({
                                                    addProductData: {
                                                      proj_id: product.proj_id,
                                                    },
                                                    })
                                                  this.handleDeleteProduct(product.prod_id)
                                                }}
                                              >
                                                <i className="ri-delete-bin-6-line" />
                                                </Button>
                                              </Col>
                                            */}

                        {/*
                                        AÇÕES DA TIMELINE DO OIKOS ANTIGO
                                        <Col className="col-md-auto d-flex flex-column">
                                        <span style={labelStyle}>
                                            Produto Final
                                          </span>
                                        <Button
                                            title="Arquivos"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => {
                                              console.log('product = ', product)
                                              this.getDocumentsOikos()
                                              this.setState({
                                              addProductData: product,
                                              addDocumentModalIsOpen: true,
                                              getDocumentsIsLoading: true,
                                            })}}

                                          >
                                            <i className="ri-attachment-line"
                                             />
                                          </Button>
                                        </Col>
                                        <Col className="col-md-auto d-flex flex-column">
                                        <span style={labelStyle}>
                                            Envio para Cliente
                                          </span>
                                        <Button
                                            title="Arquivos"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => {
                                              this.getDocumentsOikos()
                                              this.setState({
                                              addProductData: product,
                                              getDocumentsIsLoading: true,
                                              emailData: {
                                                ...emailData,
                                                destinatario: product.pj_emailPrin,
                                                assunto: product.prod_desc,
                                              },
                                              addMailModalIsOpen: true,
                                            })

                                            console.log(emailData)
                                          }}
                                          >
                                            <i className="ri-mail-fill" />
                                          </Button>
                                        </Col>
                                        */}

                        {/*
                                        {projectProducts.map(product => (
                                          <Row>
                                            <Col>
                                              <Card order={['prod_dtInterna', 'asc']}>
                                                <CardBody>
                                                  <Row className="align-items-center">
                                                    <Col>
                                                      <Row>
                                                        <Col xs="auto">
                                                          <h5 style={{ fontWeight: '500' }}>
                                                            {product.prod_desc}
                                                          </h5>
                                                        </Col>
                                                        <Col>
                                                          <Button
                                                            title="Editar"
                                                            className="ml-2"
                                                            color="light"
                                                            size="sm"
                                                            onClick={() => {
                                                              this.setState({
                                                                addProductData: product,
                                                                addProductModalIsOpen: true,
                                                                })
                                                                }}
                                                                >
                                                            <i className="ri-pencil-fill" />
                                                          </Button>
                                                        </Col>

                                                      </Row>
                                                      <Row className="mt-2 align-items-center">
                                                          <Col>
                                                            <TimelineStatusProduto
                                                              projeto={project}
                                                              produto={product}
                                                              actual={product.prodStatusActual_id || 0}
                                                              dataContratual={moment(product.prod_dtContrato).format('DD/MM/YYYY')}
                                                              tecResp={product.prod_responsavelNome}
                                                              prod_aprovCompliance={product.prod_aprovCompliance}
                                                              userOikosId={this.state.userOikosId}
                                                              prodStatusAlt_obs={product.prodStatusAlt_obs}
                                                            />
                                                          </Col>
                                                      </Row>
                                                      <a target='_blank' href={`${product.prod_drive}`}>Link para a pasta do produto</a><br />

                                                      <Row>
                                                        <Col className="col-md-auto d-flex flex-column">
                                                          <span style={labelStyle}>
                                                            Responsável
                                                          </span>
                                                          <span>
                                                            {product.prod_responsavelNome}
                                                          </span>
                                                          {product.prod_responsavelNome && (
                                                            <People
                                                              className="mt-1"
                                                              peopleQueries={[product.prod_responsavel_email]} />
                                                          )}
                                                        </Col>

                                                        <Col className="col-md-auto d-flex flex-column">
                                                          <span style={labelStyle}>
                                                            Valor
                                                          </span>
                                                          <span>
                                                            {currencyFormatter.format(product.prod_vlr)}
                                                          </span>
                                                        </Col>

                                                        <Col className="col-md-auto d-flex flex-column">
                                                          <span style={labelStyle}>
                                                            Data prevista
                                                          </span>
                                                          <span>
                                                            {moment(product.prod_dtInterna).format('DD/MM/YYYY')}
                                                          </span>
                                                        </Col>

                                                        <Col className="col-md-auto d-flex flex-column">
                                                          <span style={labelStyle}>
                                                            Data contratual
                                                          </span>
                                                          <span>
                                                            {moment(product.prod_dtContrato).format('DD/MM/YYYY')}
                                                          </span>
                                                        </Col>

                                                        <Col className="col-md-auto d-flex flex-column">
                                                          <span style={labelStyle}>
                                                            Status
                                                          </span>
                                                          <span>
                                                            {product.prodStatusTp_nome}
                                                          </span>
                                                        </Col>
                                                      </Row>
                                                    </Col>

                                                  </Row>
                                                  <Activities product={product} />
                                                </CardBody>
                                              </Card>
                                            </Col>
                                          </Row>
                                        ))}
                                        */}

                      </>
                    )}
                    {/*
                    <Button
                      size="sm"
                      color="link"
                      className="mb-1 ml-1 px-0"
                      onClick={() => this.setState({
                        addProductModalIsOpen: true,
                        addProductData: { proj_id: project.proj_id },
                      })}
                    >
                      Adicionar produto
                    </Button>
                    */}
                    <Prod userOikosId={this.state.userOikosId} userCargo={this.state.userCargo} proj_id={project.proj_id} orcRubr_id={project.orcRubr_id} projectTeam={projectTeam} />
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() =>
                        this.handleSaveReviewedTabs('produtos')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>
                    <EvePag orcRubr_id={project.orcRubr_id}></EvePag>
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('eventos_de_pagamento')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>
                    {this.state.additiveContracts?.length > 0 ? this.state.additiveContracts.map(addendum => {
                      let tipoDesc = "Outro";
                      switch (addendum.contratoInst_id) {
                        case 1: tipoDesc = "Contrato"; break;
                        case 2: tipoDesc = "Aditamento"; break;
                        case 4: tipoDesc = "Apostilamento"; break;
                        case 3: tipoDesc = "Renovação"; break;
                        case 5: tipoDesc = "Rescisão"; break;
                      }

                      return (
                        <Card key={addendum.contrato_id}>
                          <CardBody>
                            <Row>
                              <Col md={3}>
                                <Label>Tipo</Label>
                                <p style={{ fontWeight: 'bold' }}>{tipoDesc}</p>
                              </Col>

                              <Col md={3}>
                                <Label>Classificação</Label>
                                <p style={{ fontWeight: 'bold' }}>{addendum.contratoAlterTp_desc || 'Não classificada'}</p>
                              </Col>

                              <Col md={3}>
                                <Label>Data de assinatura</Label>
                                <p style={{ fontWeight: 'bold' }}>{addendum.contrato_dtAssin ? moment(addendum.contrato_dtAssin).format('DD/MM/YYYY') : '-'}</p>
                              </Col>

                              <Col md={3}>
                                <Label>Vigência</Label>
                                <p style={{ fontWeight: 'bold' }}>{addendum.contrato_prazoVigencia ? moment(addendum.contrato_prazoVigencia).format('DD/MM/YYYY') : '-'}</p>
                              </Col>

                              <Col md={3}>
                                <Label>Valor adicionado</Label>
                                <p style={{ fontWeight: 'bold' }}>{currencyFormatter.format(addendum.contrato_vlrGlobal || 0)}</p>
                              </Col>

                              <Col md={3}>
                                <Label>Prazo de execução</Label>
                                <p style={{ fontWeight: 'bold' }}>{addendum.contrato_prazoExecucao ? moment(addendum.contrato_prazoExecucao).format('DD/MM/YYYY') : '-'}</p>
                              </Col>

                              <Col md={6}>
                                <Label>Objeto</Label>
                                <p style={{ fontWeight: 'bold' }}>{addendum.contrato_obj}</p>
                              </Col>

                              <Col md={12} className="mt-3">
                                <Button size="sm" color="primary" className="mr-2" onClick={() => window.open(`${process.env.REACT_APP_URL || 'https://oikoslab.ecoss.is/'}oikos-client/comercial/contratos/${addendum.contrato_id}`, '_blank')}>Acessar Aditivo</Button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      )
                    }) : (
                      <Card>
                        <CardBody>
                          <p className="text-muted text-center mb-0">Nenhum aditivo localizado associado a este projeto.</p>
                        </CardBody>
                      </Card>
                    )}
                  </TabPanel>
                  {
                    (this.props.auth.user.perm_id === 1 || this.props.auth.user.pf_id === project.proj_coord || this.props.auth.user.pf_id === 104) &&
                    <TabPanel>
                      <ProjectFinancialResume project={project} orcRubr_id={project.orcRubr_id} userOikos={this.props.auth.user} />
                    </TabPanel>
                  }
                  <TabPanel>
                    <Tabs>
                      <TabList>
                        <Tab>Gerenciamento Interno</Tab>
                        <Tab>Vagas</Tab>
                      </TabList>
                      <TabPanel>
                        <EquiProj projId={project.proj_id} />
                      </TabPanel>
                      <TabPanel>
                        <OrcItemsProj
                          orcItems={this.state.projectState.orcItems}
                          categGrId={2}
                          propItemGrId={1}
                          projId={project.proj_id}
                          project={project}
                          orcRubrId={project.orcRubr_id}
                          currentPfId={user.pf_id}
                          propOrcItems={this.state.projectState.propOrcItems}
                          showEquipePedidoCompraFields
                          onOpenContrForn={this.handleOpenContrFornFromOrcItems}
                        />
                      </TabPanel>
                    </Tabs>
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('equipe')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>
                    <StakeProj
                      key={project.proj_id}
                      projId={project.proj_id}
                      project={project}
                      user={user}
                      refreshAt={this.state.stakeProjRefreshAt}
                    />
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('stakeholders')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>

                    {/*<DocTab refTable="contrato" refId={project.contrato_id} proj_id={project?.proj_id || this.props.match.params.id}/>*/}
                    {
                      this.state.additiveContracts &&
                      <DocTab refTable="proj" refId={project.proj_id} contrato_id={project.contrato_id} proj_id={project?.proj_id || this.props.match.params.id} additiveContractsArray={this.state.additiveContracts} />
                    }
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('documentos')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  {/*
                  <TabPanel>
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('documentos')}
                    >
                      Aba Revisada
                    </Button>}
                    <CardBody>
                      <DBSwitch table="proj" id={project.proj_id} field="proj_chkDoc" checked={project.proj_chkDoc}/>Análise de documentos
                    </CardBody>
                  </TabPanel>
                  */}
                  <TabPanel>
                    <Bordero proj_orcRubrId={projectState.orcRubr_id} proj_id={projectState.proj_id} project={projectState} />
                    {project.projSituacao_id <= 1 && <Button
                      color="primary"
                      size="md"
                      type="button"
                      onClick={() => this.handleSaveReviewedTabs('bordero')}
                    >
                      Aba Revisada
                    </Button>}
                  </TabPanel>
                  <TabPanel>
                    <MeusFornecedores
                      proj_orcRubrId={projectState.orcRubr_id}
                      proj_coord={projectState.pf_id_coordenador || project.proj_coord}
                      expandContrFornId={this.state.expandContrFornId}
                      expandCompraCotacaoId={this.state.expandCompraCotacaoId}
                      expandContrFornRequestKey={this.state.expandContrFornRequestKey}
                    />
                    {project.projSituacao_id <= 1 &&
                      <Button
                        color="primary"
                        size="md"
                        type="button"
                        onClick={() => this.handleSaveReviewedTabs('fornecedores')}
                      >
                        Aba Revisada
                      </Button>}
                  </TabPanel>
                  {/*
                  <TabPanel>
                    <Vagas />
                  </TabPanel>
                  <TabPanel>
                    <Subcontratados />
                  </TabPanel>
                  */}
                  <TabPanel>
                    {/* <BlurOverlay blurAmount='2px'>
                    </BlurOverlay> */}
                    <OrcItemsProj
                      orcItems={this.state.projectState.orcItems}
                      propOrcItems={this.state.projectState.propOrcItems}
                      categGrId={9}
                      propItemGrId={2}
                      project={project}
                      projId={project.proj_id}
                      orcRubrId={project.orcRubr_id}
                      currentPfId={user.pf_id}
                      onOpenContrForn={this.handleOpenContrFornFromOrcItems}
                    />
                  </TabPanel>
                  <TabPanel>
                    {/* <BlurOverlay blurAmount='2px'>
                    </BlurOverlay> */}
                    <OrcItemsProj
                      orcItems={this.state.projectState.orcItems}
                      propOrcItems={this.state.projectState.propOrcItems}
                      categGrId={5}
                      propItemGrId={4}
                      project={project}
                      projId={project.proj_id}
                      orcRubrId={project.orcRubr_id}
                      currentPfId={user.pf_id}
                      onOpenContrForn={this.handleOpenContrFornFromOrcItems}
                    />
                  </TabPanel>
                  <TabPanel>
                    {/* <BlurOverlay blurAmount='2px'>
                    </BlurOverlay> */}
                    <OrcItemsProj
                      orcItems={this.state.projectState.orcItems}
                      propOrcItems={this.state.projectState.propOrcItems}
                      categGrId={1}
                      propItemGrId={3}
                      project={project}
                      projId={project.proj_id}
                      orcRubrId={project.orcRubr_id}
                      currentPfId={user.pf_id}
                      onOpenContrForn={this.handleOpenContrFornFromOrcItems}
                    />
                  </TabPanel>
                  <TabPanel>
                    <Nav tabs className="nav-tabs-custom">
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projActiveSubTab === 'legal' })}
                          onClick={() => this.setState({ projActiveSubTab: 'legal' })}
                        >
                          Solicitação Jurídica
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projActiveSubTab === 'created' })}
                          onClick={() => this.setState({ projActiveSubTab: 'created' })}
                        >
                          Ofícios Criados
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projActiveSubTab === 'received' })}
                          onClick={() => this.setState({ projActiveSubTab: 'received' })}
                        >
                          Ofícios Recebidos
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <div className="d-flex justify-content-end my-3">
                      {projActiveSubTab === 'legal' && (
                        <Button color="primary" onClick={this.toggleProjLegalModal}>
                          Novo chamado
                        </Button>
                      )}
                      {projActiveSubTab === 'created' && (
                        <Button color="primary" onClick={this.toggleProjCreateLetterModal}>
                          Criar Ofício
                        </Button>
                      )}
                      {projActiveSubTab === 'received' && (
                        <Button color="success" onClick={this.toggleProjReceiveLetterModal}>
                          Receber Ofício
                        </Button>
                      )}
                    </div>

                    <Card>
                      <CardBody>
                        {projActiveSubTab === 'legal' && (
                          <DataTable
                            data={{
                              columns: [
                                { label: 'ID', field: 'id' },
                                { label: 'Solicitante', field: 'requester', sort: 'disabled' },
                                { label: 'Data de solicitação', field: 'createDt', sort: 'disabled' },
                                { label: 'Prazo desejado', field: 'endDt', sort: 'disabled' },
                                { label: 'Tipo', field: 'subject', sort: 'disabled' },
                                { label: 'Prioridade', field: 'priority', sort: 'disabled' },
                                { label: 'Contrato', field: 'contract', sort: 'disabled' },
                                { label: 'Ofício vinculado', field: 'oficio', sort: 'disabled' },
                                { label: 'Teor/Corpo', field: 'description', sort: 'disabled', searchable: false },
                                { label: 'Status', field: 'status', sort: 'disabled', searchable: false },
                                { label: 'Anexo', field: 'attachment', sort: 'disabled', searchable: false },
                                { label: 'Ações', field: 'actions', sort: 'disabled', searchable: false },
                              ],
                              rows: [...this.projLegalSolicitations]
                                .sort((a, b) => Number(b.id || b.solicitacoes_juridicas_id) - Number(a.id || a.solicitacoes_juridicas_id))
                                .map(row => ({
                                  id: row.id || row.solicitacoes_juridicas_id,
                                  requester: row.solicitante || '—',
                                  createDt: row.data_criacao ? moment(row.data_criacao).format('DD/MM/YYYY') : '—',
                                  endDt: row.prazo_atendimento ? moment(row.prazo_atendimento).format('DD/MM/YYYY') : '—',
                                  subject: row.tipo_assunto,
                                  priority: row.prioridade,
                                  contract: this.getProjContractLabel(),
                                  oficio: this.getOficioNumberBySolicitacao(row.id || row.solicitacoes_juridicas_id) || '—',
                                  description: <div dangerouslySetInnerHTML={{ __html: row.teor }} />,
                                  attachment: row.anexo ? (
                                    <a href={getOikosFileUrl(row.anexo)} onClick={e => this.openProjAnexo(e, row.anexo)} target="_blank" rel="noreferrer" title="Ver anexo">
                                      <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
                                    </a>
                                  ) : '—',
                                  status: this.formatProjSolicitationStatus(row),
                                  actions: (
                                    <div style={{ display: 'flex', gap: '8px' }}>
                                      <Button color="primary" size="sm" onClick={() => this.openProjLegalDetailsModal(row)}>
                                        Detalhes
                                      </Button>
                                    </div>
                                  ),
                                })),
                            }}
                          />
                        )}

                        {projActiveSubTab === 'created' && (
                          <DataTable
                            data={{
                              columns: [
                                { label: 'Nº Ofício', field: 'numero', sort: 'disabled' },
                                { label: 'Data do Ofício', field: 'letterDate', sort: 'disabled' },
                                { label: 'Data Envio', field: 'sendDate', sort: 'disabled' },
                                { label: 'Responsável', field: 'signer', sort: 'disabled' },
                                { label: 'Assunto', field: 'subject', sort: 'disabled' },
                                { label: 'Destinatário', field: 'recipient', sort: 'disabled' },
                                { label: 'Vínculo recebido', field: 'linkReceived', sort: 'disabled' },
                                { label: 'Demanda jurídica', field: 'legalDemand', sort: 'disabled' },
                                { label: 'Status', field: 'status', sort: 'disabled' },
                                { label: 'Anexo', field: 'attachment', sort: 'disabled' },
                                { label: 'Ações', field: 'actions', sort: 'disabled' },
                              ],
                              rows: this.projCreatedLetters.map(row => {
                                const demandId = this.getEffectiveCreatedDemandId(row)
                                return {
                                numero: row.numero_oficio || '—',
                                letterDate: row.data_oficio ? moment(row.data_oficio).format('DD/MM/YYYY') : '—',
                                sendDate: row.data_envio ? moment(row.data_envio).format('DD/MM/YYYY') : '—',
                                signer: row.responsavel_assinatura,
                                subject: row.assunto,
                                recipient: row.destinatario,
                                linkReceived: row.oficios_recebidos_id
                                  ? this.getReceivedLabel(row.oficios_recebidos_id)
                                  : '—',
                                legalDemand: demandId ? `#${demandId}` : '—',
                                attachment: row.anexo ? (
                                  <a href={getOikosFileUrl(row.anexo)} onClick={e => this.openProjAnexo(e, row.anexo)} target="_blank" rel="noreferrer" title="Ver anexo">
                                      <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
                                    </a>
                                ) : '—',
                                status: this.formatProjCreatedLetterStatus(row),
                                actions: (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 120 }}>
                                    {this.canEditRecord(row) && (
                                      <Button color="primary" size="sm" onClick={() => this.openProjEditCreatedModal(row)}>
                                        Editar
                                      </Button>
                                    )}
                                    <Button
                                      color="success"
                                      size="sm"
                                      onClick={() => this.openProjTableDemandaModal(row)}
                                      disabled={!!demandId}
                                      title={demandId ? `Demanda #${demandId} já vinculada` : ''}
                                    >
                                      Gerar demanda jurídica
                                    </Button>
                                  </div>
                                ),
                              }
                              }),
                            }}
                          />
                        )}

                        {projActiveSubTab === 'received' && (
                          <DataTable
                            data={{
                              columns: [
                                { label: 'Nº Ofício', field: 'numero', sort: 'disabled' },
                                { label: 'Data Recebimento', field: 'receiptDate', sort: 'disabled' },
                                { label: 'Data do Ofício', field: 'letterDate', sort: 'disabled' },
                                { label: 'Remetente', field: 'sender', sort: 'disabled' },
                                { label: 'Assunto/Teor', field: 'subjectBody', sort: 'disabled' },
                                { label: 'Encaminhar para', field: 'forwardTo', sort: 'disabled' },
                                { label: 'Prazo', field: 'deadline', sort: 'disabled' },
                                { label: 'Demanda jurídica', field: 'legalDemand', sort: 'disabled' },
                                { label: 'Status', field: 'status', sort: 'disabled' },
                                { label: 'Resposta', field: 'response', sort: 'disabled' },
                                { label: 'Anexo', field: 'attachment', sort: 'disabled' },
                                { label: 'Ações', field: 'actions', sort: 'disabled' },
                              ],
                              rows: this.projReceivedLetters.map(row => {
                                const editable = this.canEditRecord(row)
                                const demandId = this.getEffectiveReceivedDemandId(row)
                                return {
                                  numero: row.numero_oficio || '—',
                                  receiptDate: row.data_recebimento ? moment(row.data_recebimento).format('DD/MM/YYYY') : '—',
                                  letterDate: row.data_oficio ? moment(row.data_oficio).format('DD/MM/YYYY') : '—',
                                  sender: row.remetente,
                                  subjectBody: <div dangerouslySetInnerHTML={{ __html: row.assunto_teor }} />,
                                  forwardTo: row.encaminhar_para_email,
                                  deadline: row.tem_prazo_resposta && row.prazo_resposta
                                    ? moment(row.prazo_resposta).format('DD/MM/YYYY')
                                    : '—',
                                  legalDemand: demandId ? `#${demandId}` : '—',
                                  status: this.formatProjReceivedLetterStatus(row),
                                  response: row.oficios_criados_resposta_id
                                    ? this.getCreatedLabel(row.oficios_criados_resposta_id)
                                    : '—',
                                  attachment: row.anexo ? (
                                    <a href={getOikosFileUrl(row.anexo)} onClick={e => this.openProjAnexo(e, row.anexo)} target="_blank" rel="noreferrer" title="Ver anexo">
                                      <i className="ri-attachment-line" style={{ fontSize: '18px', color: '#556ee6' }} />
                                    </a>
                                  ) : '—',
                                  actions: (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, minWidth: 120 }}>
                                      {editable && (
                                        <Button color="secondary" size="sm" onClick={() => this.openProjEditReceivedModal(row)}>
                                          Editar
                                        </Button>
                                      )}
                                      <Button
                                        color="primary"
                                        size="sm"
                                        onClick={() => this.openProjRespondModal(row)}
                                        disabled={!!row.oficios_criados_resposta_id}
                                      >
                                        Responder
                                      </Button>
                                      <Button
                                        color="success"
                                        size="sm"
                                        onClick={() => this.openProjTableReceivedDemandaModal(row)}
                                        disabled={!!demandId}
                                        title={demandId ? `Demanda #${demandId} já vinculada` : ''}
                                      >
                                        Gerar demanda jurídica
                                      </Button>
                                    </div>
                                  ),
                                }
                              }),
                            }}
                          />
                        )}
                      </CardBody>
                    </Card>

                    {/* MODAL: SOLICITAÇÃO JURÍDICA */}
                    <Modal centered isOpen={projLegalModalOpen} toggle={this.toggleProjLegalModal} enforceFocus={false}>
                      <ModalHeader toggle={this.toggleProjLegalModal}>Novo chamado Jurídico</ModalHeader>
                      <ModalBody>
                        <FormGroup style={{ position: 'relative', zIndex: 100001 }}>
                          <Label>Tipo</Label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Tipo"
                            value={projLegalSubject}
                            options={projSubjectOptions || []}
                            onChange={val => this.setState({ projLegalSubject: val, projLegalSubjectError: '' })}
                          />
                          {projLegalSubjectError && <span style={{ color: 'red' }}>{projLegalSubjectError}</span>}
                        </FormGroup>
                        <FormGroup style={{ position: 'relative', zIndex: 100000 }}>
                          <Label>Prioridade</Label>
                          <Select
                            className="basic-single"
                            classNamePrefix="select"
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Prioridade"
                            value={projLegalPriority}
                            options={projPriorities || []}
                            onChange={val => this.setState({ projLegalPriority: val, projLegalPriorityError: '' })}
                          />
                          {projLegalPriorityError && <span style={{ color: 'red' }}>{projLegalPriorityError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Fato Gerador <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="text"
                            placeholder=""
                            value={projLegalFatoGerador}
                            onChange={e => this.setState({ projLegalFatoGerador: e.target.value })}
                          />
                        </FormGroup>
                        <FormGroup style={{ position: 'relative', zIndex: projLegalDateOpen ? 100002 : 99999 }}>
                          <Label>Prazo de atendimento desejado</Label>
                          <div>
                            <DatePicker
                              locale="pt-BR"
                              className="form-control"
                              selected={projLegalDate}
                              minDate={new Date()}
                              dateFormat="dd/MM/yyyy"
                              onChange={date => this.setState({ projLegalDate: date, projLegalDateError: '' })}
                              onCalendarOpen={() => this.setState({ projLegalDateOpen: true })}
                              onCalendarClose={() => this.setState({ projLegalDateOpen: false })}
                            />
                          </div>
                          {projLegalDateError && <span style={{ color: 'red' }}>{projLegalDateError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Teor/Corpo</Label>
                          <div style={{
                            border: projLegalDescriptionError ? '1px solid red' : '1px solid #ced4da',
                            borderRadius: 4,
                            minHeight: 150,
                            padding: 2,
                          }}>
                            <FastEditor
                              editorState={projLegalDescription}
                              onChange={editorState => this.setState({ projLegalDescription: editorState, projLegalDescriptionError: '' })}
                            />
                          </div>
                          {projLegalDescriptionError && <span style={{ color: 'red', fontSize: 12 }}>{projLegalDescriptionError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Anexar arquivo <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="file"
                            onChange={e => this.setState({ projLegalAttachment: e.target.files[0] || null })}
                          />
                          {projLegalAttachment && (
                            <span style={{ fontSize: 12, color: '#555', marginTop: 4, display: 'block' }}>
                              📎 {projLegalAttachment.name}
                            </span>
                          )}
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="light" onClick={this.toggleProjLegalModal}>Cancelar</Button>
                        <Button color="primary" onClick={this.handleProjLegalSubmit}>Enviar</Button>
                      </ModalFooter>
                    </Modal>

                    <ProjLegalDetailsModal
                      isOpen={projLegalDetailsModalOpen}
                      toggle={this.toggleProjLegalDetailsModal}
                      solicitation={projLegalSelected}
                      pfList={this.state.pfList}
                      userOikosId={this.state.userOikosId}
                      formatProjSolicitationStatus={this.formatProjSolicitationStatus}
                      getProjContractLabel={this.getProjContractLabel}
                    />

                    {/* MODAL: CRIAR OFÍCIO */}
                    <OfficialLetterSubmitOverlay
                      isOpen={
                        this.props.postOfficialLetterCreatedIsLoading
                        || this.props.postOfficialLetterReceivedIsLoading
                      }
                      message={
                        this.props.postOfficialLetterReceivedIsLoading
                          ? 'Salvando ofício recebido...'
                          : 'Salvando ofício criado...'
                      }
                    />
                    <Modal size="lg" scrollable centered enforceFocus={false} isOpen={projCreateLetterModalOpen} toggle={this.toggleProjCreateLetterModal} backdrop={this.props.postOfficialLetterCreatedIsLoading ? 'static' : true}>
                      <ModalHeader toggle={this.props.postOfficialLetterCreatedIsLoading ? undefined : this.toggleProjCreateLetterModal}>
                        {projRespondToReceived ? 'Responder Ofício (criar ofício vinculado)' : 'Criar Novo Ofício'}
                      </ModalHeader>
                      <ModalBody className="official-letters-modal">
                        <FormGroup>
                          <Label>Número do ofício</Label>
                          <Input type="text" placeholder="2026/001" value={projCreateNumero}
                            onChange={e => this.setState({ projCreateNumero: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Responsável da assinatura</Label>
                          <Input
                            type="text"
                            value={projCreateSigner}
                            onChange={e => this.setState({ projCreateSigner: e.target.value, projCreateSignerError: '' })}
                          />
                          {projCreateSignerError && <span style={{ color: 'red' }}>{projCreateSignerError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Assunto</Label>
                          <Input
                            type="text"
                            value={projCreateSubject}
                            onChange={e => this.setState({ projCreateSubject: e.target.value, projCreateSubjectError: '' })}
                          />
                          {projCreateSubjectError && <span style={{ color: 'red' }}>{projCreateSubjectError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Contrato vinculado</Label>
                          <Input
                            type="text"
                            value={this.getProjContractLabel()}
                            disabled
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>Data do ofício</Label>
                          <div>
                            <ModalDatePicker
                              selected={projCreateDate}
                              onChange={date => this.setState({ projCreateDate: date, projCreateDateError: '' })}
                            />
                          </div>
                          {projCreateDateError && <span style={{ color: 'red' }}>{projCreateDateError}</span>}
                        </FormGroup>
                        <Row>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Data de envio <span style={{ color: '#888' }}>(opcional)</span></Label>
                              <ModalDatePicker selected={projCreateSendDate} isClearable
                                onChange={date => this.setState({ projCreateSendDate: date })} />
                            </FormGroup>
                          </Col>
                          <Col md={6}>
                            <FormGroup>
                              <Label>Data de recebimento <span style={{ color: '#888' }}>(opcional)</span></Label>
                              <ModalDatePicker selected={projCreateReceiveDate} isClearable
                                onChange={date => this.setState({ projCreateReceiveDate: date })} />
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <Label>Destinatário</Label>
                          <Input
                            type="text"
                            value={projCreateRecipient}
                            onChange={e => this.setState({ projCreateRecipient: e.target.value, projCreateRecipientError: '' })}
                          />
                          {projCreateRecipientError && <span style={{ color: 'red' }}>{projCreateRecipientError}</span>}
                        </FormGroup>
                        {!projRespondToReceived && (
                          <FormGroup>
                            <Label>Vincular a ofício recebido <span style={{ color: '#888' }}>(opcional)</span></Label>
                            <Select
                              {...MODAL_SELECT_PROPS}
                              isClearable
                              placeholder="Selecione..."
                              value={projCreateLinkReceived}
                              options={this.projReceivedLetters.map(r => ({
                                value: getRowId(r, false),
                                label: this.getReceivedLabel(getRowId(r, false)),
                              }))}
                              onChange={opt => this.setState({ projCreateLinkReceived: opt })}
                            />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <Label>Teor</Label>
                          <div style={{
                            ...EDITOR_WRAPPER_STYLE,
                            border: projCreateBodyError ? '1px solid red' : EDITOR_WRAPPER_STYLE.border,
                          }}>
                            <FastEditor
                              editorState={projCreateBody}
                              onChange={editorState => this.setState({ projCreateBody: editorState, projCreateBodyError: '' })}
                            />
                          </div>
                          {projCreateBodyError && <span style={{ color: 'red', fontSize: 12 }}>{projCreateBodyError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <CustomInput type="checkbox" id="projCreateGerarDemanda" label="Gerar demanda jurídica?"
                            checked={projCreateGerarDemanda}
                            disabled={!!this.getProjCreateFormBlockedDemandId()}
                            onChange={this.handleProjCreateGerarDemandaChange} />
                          {!!this.getProjCreateFormBlockedDemandId() && (
                            <div style={{ marginTop: 6, fontSize: 12, color: '#856404' }}>
                              Demanda #{this.getProjCreateFormBlockedDemandId()} já vinculada ao ofício recebido.
                            </div>
                          )}
                          {projCreateGerarDemanda && projCreateDemandaJuridica && (
                            <div style={{ marginTop: 8, fontSize: 13 }}>
                              <span className="text-muted">
                                {projCreateDemandaJuridica.tipo_assunto} · {projCreateDemandaJuridica.prioridade}
                                {' · '}
                                {moment(projCreateDemandaJuridica.prazo_atendimento).format('DD/MM/YYYY')}
                              </span>
                              {' '}
                              <Button color="link" size="sm" className="p-0 align-baseline" onClick={this.openProjCreateDemandaModal}>
                                Editar
                              </Button>
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label>Observações <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="textarea"
                            rows="3"
                            value={projCreateObservations}
                            onChange={e => this.setState({ projCreateObservations: e.target.value })}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>Anexar arquivo <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="file"
                            onChange={e => this.setState({ projCreateAttachment: e.target.files[0] || null })}
                          />
                          {projCreateAttachment && (
                            <span style={{ fontSize: 12, color: '#555', marginTop: 4, display: 'block' }}>
                              📎 {projCreateAttachment.name}
                            </span>
                          )}
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="light" onClick={this.toggleProjCreateLetterModal} disabled={this.props.postOfficialLetterCreatedIsLoading}>Cancelar</Button>
                        <Button color="primary" onClick={this.handleProjCreateLetterSubmit} disabled={this.props.postOfficialLetterCreatedIsLoading}>
                          {this.props.postOfficialLetterCreatedIsLoading
                            ? <><Spinner size="sm" className="mr-2" />Enviando...</>
                            : 'Enviar'}
                        </Button>
                      </ModalFooter>
                    </Modal>

                    <LegalDemandOptionsModal
                      isOpen={projCreateDemandaModalOpen}
                      toggle={() => this.closeProjCreateDemandaModal(true)}
                      defaults={this.state.projCreateDemandaDefaults}
                      contractLabel={this.getProjContractLabel()}
                      onConfirm={this.handleProjCreateDemandaConfirm}
                    />

                    <LegalDemandOptionsModal
                      isOpen={projReceiveDemandaModalOpen}
                      toggle={() => this.closeProjReceiveDemandaModal(true)}
                      defaults={this.state.projReceiveDemandaDefaults}
                      contractLabel={this.getProjContractLabel()}
                      onConfirm={this.handleProjReceiveDemandaConfirm}
                    />

                    <LegalDemandOptionsModal
                      isOpen={this.state.projTableDemandaModalOpen}
                      toggle={this.closeProjTableDemandaModal}
                      defaults={this.state.projTableDemandaDefaults}
                      contractLabel={this.getProjContractLabel()}
                      onConfirm={this.handleProjTableDemandaConfirm}
                    />

                    <LegalDemandOptionsModal
                      isOpen={this.state.projTableReceivedDemandaModalOpen}
                      toggle={this.closeProjTableReceivedDemandaModal}
                      defaults={this.state.projTableReceivedDemandaDefaults}
                      contractLabel={this.getProjContractLabel()}
                      onConfirm={this.handleProjTableReceivedDemandaConfirm}
                    />

                    {/* MODAL: RECEBER OFÍCIO */}
                    <Modal size="lg" scrollable centered enforceFocus={false} isOpen={projReceiveLetterModalOpen} toggle={this.toggleProjReceiveLetterModal} backdrop={this.props.postOfficialLetterReceivedIsLoading ? 'static' : true}>
                      <ModalHeader toggle={this.props.postOfficialLetterReceivedIsLoading ? undefined : this.toggleProjReceiveLetterModal}>Receber Ofício</ModalHeader>
                      <ModalBody className="official-letters-modal">
                        <FormGroup>
                          <Label>Número do ofício do cliente</Label>
                          <Input type="text" placeholder="Ex.: 12345/2026" value={projReceiveNumero}
                            onChange={e => this.setState({ projReceiveNumero: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Remetente</Label>
                          <Input
                            type="text"
                            value={projReceiveSender}
                            onChange={e => this.setState({ projReceiveSender: e.target.value, projReceiveSenderError: '' })}
                          />
                          {projReceiveSenderError && <span style={{ color: 'red' }}>{projReceiveSenderError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Contrato vinculado <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="text"
                            value={this.getProjContractLabel()}
                            disabled
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>Data de recebimento</Label>
                          <div>
                            <ModalDatePicker
                              selected={projReceiveDate}
                              onChange={date => this.setState({ projReceiveDate: date, projReceiveDateError: '' })}
                            />
                          </div>
                          {projReceiveDateError && <span style={{ color: 'red' }}>{projReceiveDateError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Data de ofício</Label>
                          <div>
                            <ModalDatePicker
                              selected={projReceiveLetterDate}
                              onChange={date => this.setState({ projReceiveLetterDate: date, projReceiveLetterDateError: '' })}
                            />
                          </div>
                          {projReceiveLetterDateError && <span style={{ color: 'red' }}>{projReceiveLetterDateError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <Label>Assunto/Teor</Label>
                          <div style={{
                            ...EDITOR_WRAPPER_STYLE,
                            border: projReceiveSubjectBodyError ? '1px solid red' : EDITOR_WRAPPER_STYLE.border,
                          }}>
                            <FastEditor
                              editorState={projReceiveSubjectBody}
                              onChange={editorState => this.setState({ projReceiveSubjectBody: editorState, projReceiveSubjectBodyError: '' })}
                            />
                          </div>
                          {projReceiveSubjectBodyError && <span style={{ color: 'red', fontSize: 12 }}>{projReceiveSubjectBodyError}</span>}
                        </FormGroup>
                        <FormGroup className="mb-4">
                          <Label>Encaminhar para (gerências)</Label>
                          <Select
                            {...MODAL_MULTI_SELECT_PROPS}
                            isMulti
                            placeholder="Selecione..."
                            value={projReceiveForwardDepartments}
                            options={PROJECT_FORWARD_EMAIL_OPTIONS}
                            onChange={selected => this.setState({
                              projReceiveForwardDepartments: selected || [],
                              projReceiveForwardDepartmentsError: '',
                            })}
                          />
                          {projReceiveForwardDepartmentsError && <span style={{ color: 'red' }}>{projReceiveForwardDepartmentsError}</span>}
                        </FormGroup>
                        <FormGroup>
                          <CustomInput type="checkbox" id="projReceiveTemPrazo" label="Prazo para resposta?"
                            checked={projReceiveTemPrazo}
                            onChange={e => this.setState({ projReceiveTemPrazo: e.target.checked, projReceivePrazo: e.target.checked ? projReceivePrazo : '' })} />
                        </FormGroup>
                        {projReceiveTemPrazo && (
                          <FormGroup>
                            <Label>Prazo para resposta</Label>
                            <ModalDatePicker selected={projReceivePrazo}
                              onChange={date => this.setState({ projReceivePrazo: date })} />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <CustomInput
                            type="checkbox"
                            id="projReceiveGerarDemanda"
                            label="Gerar demanda jurídica?"
                            checked={projReceiveGerarDemanda}
                            onChange={this.handleProjReceiveGerarDemandaChange}
                          />
                          {projReceiveGerarDemanda && projReceiveDemandaJuridica && (
                            <div style={{ marginTop: 8, fontSize: 13 }}>
                              <span className="text-muted">
                                {projReceiveDemandaJuridica.tipo_assunto} · {projReceiveDemandaJuridica.prioridade}
                                {' · '}
                                {moment(projReceiveDemandaJuridica.prazo_atendimento).format('DD/MM/YYYY')}
                              </span>
                              {' '}
                              <Button color="link" size="sm" className="p-0 align-baseline" onClick={this.openProjReceiveDemandaModal}>
                                Editar
                              </Button>
                            </div>
                          )}
                        </FormGroup>
                        <FormGroup>
                          <Label>Com cópia para <span style={{ color: '#888' }}>(opcional)</span></Label>
                          <Input type="text" value={projReceiveCcEmail} onChange={e => this.setState({ projReceiveCcEmail: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Observações <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="textarea"
                            rows="3"
                            value={projReceiveObservations}
                            onChange={e => this.setState({ projReceiveObservations: e.target.value })}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>Anexar arquivo <span style={{ color: '#888', fontWeight: 'normal' }}>(opcional)</span></Label>
                          <Input
                            type="file"
                            onChange={e => this.setState({ projReceiveAttachment: e.target.files[0] || null })}
                          />
                          {projReceiveAttachment && (
                            <span style={{ fontSize: 12, color: '#555', marginTop: 4, display: 'block' }}>
                              📎 {projReceiveAttachment.name}
                            </span>
                          )}
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="light" onClick={this.toggleProjReceiveLetterModal} disabled={this.props.postOfficialLetterReceivedIsLoading}>Cancelar</Button>
                        <Button color="primary" onClick={this.handleProjReceiveLetterSubmit} disabled={this.props.postOfficialLetterReceivedIsLoading}>
                          {this.props.postOfficialLetterReceivedIsLoading
                            ? <><Spinner size="sm" className="mr-2" />Enviando...</>
                            : 'Enviar'}
                        </Button>
                      </ModalFooter>
                    </Modal>

                    {/* MODAL: EDITAR OFÍCIO CRIADO */}
                    <Modal size="lg" scrollable centered enforceFocus={false} isOpen={projEditCreatedModalIsOpen} toggle={this.closeProjEditCreatedModal}>
                      <ModalHeader toggle={this.closeProjEditCreatedModal}>Editar Ofício Criado</ModalHeader>
                      <ModalBody className="official-letters-modal">
                        <FormGroup>
                          <Label>Número do ofício</Label>
                          <Input type="text" value={projEditCreatedNumero}
                            onChange={e => this.setState({ projEditCreatedNumero: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Status</Label>
                          <Input type="select" value={projEditCreatedStatus}
                            onChange={e => this.setState({ projEditCreatedStatus: e.target.value })}>
                            {CREATED_STATUS_OPTIONS.map(opt => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </Input>
                        </FormGroup>
                        <FormGroup>
                          <Label>Responsável da assinatura</Label>
                          <Input type="text" value={projEditCreatedSigner}
                            onChange={e => this.setState({ projEditCreatedSigner: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Assunto</Label>
                          <Input type="text" value={projEditCreatedSubject}
                            onChange={e => this.setState({ projEditCreatedSubject: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Contrato vinculado</Label>
                          <Input type="text" value={this.getProjContractLabel()} disabled />
                        </FormGroup>
                        <Row>
                          <Col md={4}>
                            <FormGroup>
                              <Label>Data do ofício</Label>
                              <ModalDatePicker selected={projEditCreatedDate}
                                onChange={date => this.setState({ projEditCreatedDate: date })} />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label>Data de envio</Label>
                              <ModalDatePicker selected={projEditCreatedSendDate} isClearable
                                onChange={date => this.setState({ projEditCreatedSendDate: date })} />
                            </FormGroup>
                          </Col>
                          <Col md={4}>
                            <FormGroup>
                              <Label>Data de recebimento</Label>
                              <ModalDatePicker selected={projEditCreatedReceiveDate} isClearable
                                onChange={date => this.setState({ projEditCreatedReceiveDate: date })} />
                            </FormGroup>
                          </Col>
                        </Row>
                        <FormGroup>
                          <Label>Destinatário</Label>
                          <Input type="text" value={projEditCreatedRecipient}
                            onChange={e => this.setState({ projEditCreatedRecipient: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Vincular a ofício recebido</Label>
                          <Select
                            {...MODAL_SELECT_PROPS}
                            isClearable
                            placeholder="Selecione..."
                            value={projEditCreatedLinkReceived}
                            options={this.projReceivedLetters.map(r => ({
                              value: getRowId(r, false),
                              label: this.getReceivedLabel(getRowId(r, false)),
                            }))}
                            onChange={opt => this.setState({ projEditCreatedLinkReceived: opt })}
                          />
                        </FormGroup>
                        <FormGroup>
                          <Label>Teor</Label>
                          <div style={EDITOR_WRAPPER_STYLE}>
                            <FastEditor
                              editorState={projEditCreatedBody}
                              onChange={editorState => this.setState({ projEditCreatedBody: editorState })}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <Label>Observações</Label>
                          <Input type="textarea" rows="2" value={projEditCreatedObservations}
                            onChange={e => this.setState({ projEditCreatedObservations: e.target.value })} />
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="light" onClick={this.closeProjEditCreatedModal}>Cancelar</Button>
                        <Button color="primary" onClick={this.handleProjEditCreatedSubmit}>Salvar</Button>
                      </ModalFooter>
                    </Modal>

                    {/* MODAL: EDITAR OFÍCIO RECEBIDO */}
                    <Modal size="lg" scrollable centered enforceFocus={false} isOpen={projEditReceivedModalIsOpen} toggle={this.closeProjEditReceivedModal}>
                      <ModalHeader toggle={this.closeProjEditReceivedModal}>Editar Ofício Recebido</ModalHeader>
                      <ModalBody className="official-letters-modal">
                        <FormGroup>
                          <Label>Número do ofício do cliente</Label>
                          <Input type="text" value={projEditReceivedNumero}
                            onChange={e => this.setState({ projEditReceivedNumero: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Remetente</Label>
                          <Input type="text" value={projEditReceivedSender}
                            onChange={e => this.setState({ projEditReceivedSender: e.target.value })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Contrato vinculado</Label>
                          <Input type="text" value={this.getProjContractLabel()} disabled />
                        </FormGroup>
                        <FormGroup>
                          <Label>Data de recebimento</Label>
                          <ModalDatePicker selected={projEditReceivedDate}
                            onChange={date => this.setState({ projEditReceivedDate: date })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Data do ofício</Label>
                          <ModalDatePicker selected={projEditReceivedLetterDate}
                            onChange={date => this.setState({ projEditReceivedLetterDate: date })} />
                        </FormGroup>
                        <FormGroup>
                          <Label>Assunto/Teor</Label>
                          <div style={EDITOR_WRAPPER_STYLE}>
                            <FastEditor
                              editorState={projEditReceivedSubjectBody}
                              onChange={editorState => this.setState({ projEditReceivedSubjectBody: editorState })}
                            />
                          </div>
                        </FormGroup>
                        <FormGroup>
                          <Label>Encaminhado para</Label>
                          <Input type="text" disabled value={projEditingReceivedRow?.setor_responsavel || '—'} />
                          <small className="text-muted">Definido na criação; a edição não reenvia e-mail.</small>
                        </FormGroup>
                        <FormGroup>
                          <CustomInput type="checkbox" id="projEditReceivedTemPrazo" label="Prazo para resposta?"
                            checked={projEditReceivedTemPrazo}
                            onChange={e => this.setState({
                              projEditReceivedTemPrazo: e.target.checked,
                              projEditReceivedPrazo: e.target.checked ? projEditReceivedPrazo : '',
                            })} />
                        </FormGroup>
                        {projEditReceivedTemPrazo && (
                          <FormGroup>
                            <Label>Prazo para resposta</Label>
                            <ModalDatePicker selected={projEditReceivedPrazo}
                              onChange={date => this.setState({ projEditReceivedPrazo: date })} />
                          </FormGroup>
                        )}
                        <FormGroup>
                          <Label>Observações</Label>
                          <Input type="textarea" rows="2" value={projEditReceivedObservations}
                            onChange={e => this.setState({ projEditReceivedObservations: e.target.value })} />
                        </FormGroup>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="light" onClick={this.closeProjEditReceivedModal}>Cancelar</Button>
                        <Button color="primary" onClick={this.handleProjEditReceivedSubmit}>Salvar</Button>
                      </ModalFooter>
                    </Modal>
                  </TabPanel>
                  <TabPanel>
                    <Nav tabs className="nav-tabs-custom">
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projMarketingSubTab === 'case' })}
                          onClick={() => this.setState({ projMarketingSubTab: 'case' })}
                        >
                          Case
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projMarketingSubTab === 'pesquisa' })}
                          onClick={() => this.setState({ projMarketingSubTab: 'pesquisa' })}
                        >
                          Pesquisa
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          style={{ cursor: 'pointer' }}
                          className={classnames({ active: projMarketingSubTab === 'atestado' })}
                          onClick={() => this.setState({ projMarketingSubTab: 'atestado' })}
                        >
                          Atestado
                        </NavLink>
                      </NavItem>
                    </Nav>

                    <Card className="mt-3">
                      <CardBody>
                        {projMarketingSubTab === 'case' && (
                          <MarketingCaseForm project={project} />
                        )}
                        {projMarketingSubTab === 'pesquisa' && (
                          <MarketingPesquisaForm project={project} />
                        )}
                        {projMarketingSubTab === 'atestado' && (
                          <p className="text-muted mb-0">Atestado — conteúdo em breve.</p>
                        )}
                      </CardBody>
                    </Card>
                  </TabPanel>
                  <TabPanel>
                    <ProjDadosTab project={project} />
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>
          </Container>
        </div>
          <>
            <Modal
              centered={false}
              isOpen={addProductModalIsOpen}
              toggle={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
            >
              <ModalHeader
                toggle={() => this.setState({
                  addProductData: {},
                  addProductModalIsOpen: false,
                })}
              >
                Adicionar produto
              </ModalHeader>
              <ModalBody>
                <FormGroup>
                  <Label>
                    Descrição
                  </Label>
                  <Input
                    value={addProductData?.prod_desc}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_desc: e.target.value || null,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Formato do produto final
                  </Label>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={getTeamIsLoading}
                    value={['.pdf', '.docx', '.xlsx'].filter(x => (x === addProductData.prod_formato))}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_formato: e,
                      },
                    })}
                    placeholder="Formato"
                    options={['.pdf', '.docx', '.xlsx']}
                    getOptionValue={option => option}
                    getOptionLabel={option => option}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>Responsável</Label>
                  <Select
                    isSearchable
                    isClearable
                    isLoading={getTeamIsLoading}
                    value={projectTeam.filter(x => (x.id === addProductData.prod_responsavel))}
                    onChange={e => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_responsavel: e.id,
                      },
                    })}
                    placeholder="Responsável"
                    options={projectTeam}
                    getOptionValue={option => option.id}
                    getOptionLabel={option => option.nome}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Valor
                  </Label>
                  <MaskedInput
                    unmask
                    mask="R$ num"
                    blocks={{
                      num: {
                        mask: Number,
                        scale: 2, // digits after point 0 for integers
                        signed: false, // disallow negative
                        thousandsSeparator: '.', // any single char
                        padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                        normalizeZeros: false, // appends or removes zeros at ends
                        radix: ',', // fractional delimiter
                        min: 0,
                        max: 1000000000,
                      },
                    }}
                    lazy={false}
                    value={String(addProductData.prod_vlr)}
                    onAccept={value => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_vlr: value,
                      },
                    })}
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data prevista
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtInterna ? moment(addProductData.prod_dtInterna).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtInterna: date,
                        prod_dtInterna_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data contratual
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtContrato ? moment(addProductData.prod_dtContrato).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtContrato: date,
                        prod_dtContrato_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data entrega
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtEntrega ? moment(addProductData.prod_dtEntrega).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtEntrega: date,
                        prod_dtEntrega_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data aprovação
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtAprov ? moment(addProductData.prod_dtAprov).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtAprov: date,
                        prod_dtAprov_Invalid: false,
                      },
                    })} />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Data limite para aprovação
                  </Label>

                  <DatePicker
                    placeholderText="__/__/_____"
                    locale="pt-BR"
                    className="form-control"
                    dateFormat="dd/MM/yyyy"
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    selected={addProductData?.prod_dtLimAprov ? moment(addProductData.prod_dtLimAprov).toDate() : null}
                    onChange={date => this.setState({
                      addProductData: {
                        ...addProductData,
                        prod_dtLimAprov: date,
                        prod_dtLimAprov_Invalid: false,
                      },
                    })} />
                </FormGroup>
                {/*
                <FormGroup>
                  <Label>
                    Status
                  </Label>
                  <Select
                  classNamePrefix="select2-selection"
                  placeholder="Selecionar..."
                  value={selTpStatus && selTpStatus?.filter(x => (x.value === addProductData.prodStatusTp_id))}
                  options={x   || []}
                  isDisabled={!selTpStatus}
                  isLoading={!selTpStatus}
                  onChange={e => this.setState( {
                    addProductData: {
                    ...addProductData,
                    prodStatusTp_id: e.value
                    }
                  })}
                />
                </FormGroup>
                */}


                <FormGroup>
                  <Label>Tem faturamento associado</Label>
                  <Select
                    isSearchable={false}
                    value={[{ prodFatFlag_id: 0, prodFatFlag_nome: 'Não' }, { prodFatFlag_id: 1, prodFatFlag_nome: 'Sim' }]
                      .filter((x) => Number(x.prodFatFlag_id) === Number(addProductData?.prodFatFlag_id || 0))}
                    onChange={(e) => this.setState({
                      addProductData: {
                        ...addProductData,
                        prodFatFlag_id: e ? Number(e.prodFatFlag_id) : 0,
                      },
                    })}
                    options={[
                      { prodFatFlag_id: 0, prodFatFlag_nome: 'Não' },
                      { prodFatFlag_id: 1, prodFatFlag_nome: 'Sim' },
                    ]}
                    getOptionValue={(option) => option.prodFatFlag_id}
                    getOptionLabel={(option) => option.prodFatFlag_nome}
                    placeholder="Não"
                  />
                </FormGroup>

                <FormGroup>
                  <Label>
                    Evento de faturamento
                    {Number(addProductData?.prodFatFlag_id) === 1 ? ' *' : ''}
                  </Label>
                  <Select
                    isSearchable
                    isClearable={Number(addProductData?.prodFatFlag_id) !== 1}
                    isDisabled={!project?.orcRubr_id}
                    value={(recList || []).filter((x) => String(x.rec_id) === String(addProductData?.rec_id))}
                    onChange={(e) => this.setState({
                      addProductData: {
                        ...addProductData,
                        rec_id: e ? e.rec_id : null,
                      },
                    })}
                    options={recList || []}
                    getOptionValue={(option) => option.rec_id}
                    getOptionLabel={(option) => {
                      const ep = option.rec_ep != null ? String(option.rec_ep) : ''
                      return ep ? `${option.rec_id} – ${ep}` : String(option.rec_id)
                    }}
                    placeholder={project?.orcRubr_id
                      ? (Number(addProductData?.prodFatFlag_id) === 1
                        ? 'Obrigatório — selecione o evento'
                        : 'Opcional')
                      : 'Projeto sem rubrica de orçamento'}
                  />
                </FormGroup>

              </ModalBody>
              <ModalFooter>
                <Button
                  type="button"
                  onClick={() => this.setState({ addProductData: {}, addProductModalIsOpen: false })}
                  color="light"
                  className="waves-effect"
                >
                  Cancelar
                </Button>
                <Button
                  type="button"
                  color="primary"
                  className="waves-effect waves-light"
                  onClick={() => this.handleSubmitProduct()}
                  disabled={!addProductData?.prod_desc
                    || !addProductData?.prod_dtInterna
                    || (Number(addProductData?.prodFatFlag_id) === 1
                      && (addProductData?.rec_id == null || addProductData.rec_id === ''))}
                >
                  Adicionar
                </Button>
              </ModalFooter>
            </Modal>
            <Modal
              size="lg"
              centered={false}
              isOpen={addDocumentModalIsOpen}
              toggle={() => this.setState({ addDocumentData: {}, addDocumentModalIsOpen: false })}
            >
              <ModalHeader
                toggle={() => this.setState({
                  addDocumentData: {},
                  addDocumentModalIsOpen: false,
                })}
              >
                Produto entregue
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Col>
                    <FormGroup>
                      Anexos
                      <Container>
                        {

                          documents.filter(doc => doc.name.includes(addProductData.IdSP)).map(doc => (
                            <Row>
                              <Col>
                                <Card>
                                  <CardBody>
                                    <Row className="align-items-center">
                                      <Col>
                                        <Row>
                                          <Col>
                                            <FormGroup className="col-md-auto d-flex flex-column">
                                              <span>
                                                <a
                                                  title={doc.name}
                                                  href={doc.webUrl}
                                                  target="_blank"
                                                  isLoading={getDocumentsIsLoading}
                                                  rel="noreferrer"
                                                >
                                                  <i className="ri-attachment-line" />

                                                </a>
                                              </span>
                                              <span style={labelStyle}> {doc.name} {addProductData.IdSP}  </span>
                                            </FormGroup>

                                          </Col>
                                        </Row>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          ))}
                      </Container>

                    </FormGroup>
                    <Container>
                      <FormGroup className="col-md-auto d-flex flex-column">

                        <span style={labelStyle}>
                          Data entrega do documento
                        </span>
                        <span>
                          {moment(addProductData.prod_dtEntrega).format('DD/MM/YYYY')}
                        </span>
                      </FormGroup>
                      <FormGroup className="col-md-auto d-flex flex-column">
                        <span style={labelStyle}>
                          Observações do técnico responsável
                        </span>
                        <span>
                          {addProductData.prod_obsResp}
                        </span>
                      </FormGroup>
                      <FormGroup className="col-md-auto d-flex flex-column">
                        <span style={labelStyle}>
                          Observações Compliance
                        </span>
                        <span>
                          {addProductData?.prod_obsCompliance}
                        </span>
                      </FormGroup>
                    </Container>
                  </Col>
                  <Col>
                    <FormGroup >
                      Avaliação da Gestão
                      <Container>
                        <Label>
                          Conteúdo
                        </Label>
                        <Select
                          isSearchable
                          isClearable
                          isLoading={getAvalIsLoading}
                          value={aval.filter(x => (x.aval_id === addProductData.prod_avalEP))}
                          onChange={e => this.setState({
                            addProductData: {
                              ...addProductData,
                              prod_avalEP: e.aval_id,
                            },
                          })}
                          options={aval}
                          getOptionValue={option => option.aval_id}
                          getOptionLabel={option => option.aval_desc}
                        />
                      </Container>
                    </FormGroup>
                    <FormGroup>
                      <Container>
                        <Label>
                          Aprovação
                        </Label>
                        <Select
                          isSearchable
                          isClearable
                          isLoading={getAprovIsLoading}
                          value={aprov.filter(x => (x.aprov_id === addProductData.prod_aprovEP))}
                          onChange={e => this.setState({
                            addProductData: {
                              ...addProductData,
                              prod_aprovEP: e.aprov_id,
                            },
                          })}
                          options={aprov}
                          getOptionValue={option => option.aprov_id}
                          getOptionLabel={option => option.aprov_desc}
                        />
                      </Container>
                    </FormGroup>
                    <FormGroup>
                      <Container>
                        <Label>
                          Observações
                        </Label>
                        <Input
                          type="textarea"
                          value={addProductData?.prod_obsEP}
                          onChange={e => this.setState({
                            addProductData: {
                              ...addProductData,
                              prod_obsEP: e.target.value || null,
                            },
                          })} />
                      </Container>
                    </FormGroup>
                  </Col>
                </Row>
                <ModalFooter>
                  <Button
                    type="button"
                    onClick={() => this.setState({ addDocumentData: {}, addDocumentModalIsOpen: false })}
                    color="light"
                    className="waves-effect"
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="button"
                    color="primary"
                    className="waves-effect waves-light"
                    onClick={() => this.handleSubmitProduct()}
                    disabled={!addProductData?.prod_aprovEP
                      || !addProductData?.prod_avalEP
                      || !addProductData?.prod_obsEP}
                  >
                    Atualizar
                  </Button>
                </ModalFooter>

              </ModalBody>
            </Modal>
            <Modal
              size="lg"
              centered={false}
              isOpen={addMailModalIsOpen}
              toggle={() => this.setState({ addDocumentData: {}, addMailModalIsOpen: false })}
            >
              <ModalHeader
                toggle={() => this.setState({
                  addDocumentData: {},
                  addMailModalIsOpen: false,
                })}
              >
                Envio para Cliente
              </ModalHeader>
              <ModalBody>
                <Tabs>
                  <TabList>
                    <Tab>   Anexos  </Tab>
                    <Tab>   Email   </Tab>
                  </TabList>
                  <TabPanel>

                    <Row>
                      <Col>
                        <FormGroup>
                          Produto Final
                          <Container>
                            <AddFiles
                              drop={false}
                              multiple={false}
                              ref={this.prodFinalFileRef}
                            />

                          </Container>

                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          Anexos
                          <Container>

                          </Container>
                          <AddContractFiles
                            ref={this.filesRef}
                          />

                        </FormGroup>
                      </Col>

                      <Col sm={12}>
                        <Container>
                          <ModalFooter>
                            <Button
                              type="button"
                              color="primary"
                              className="waves-effect waves-light"
                              onClick={() => {
                                this.getDocumentsOikos()
                                this.handleAddDocSubmit()
                              }
                              }
                            >
                              Anexar
                            </Button>
                          </ModalFooter>
                        </Container>
                      </Col>
                    </Row>
                    {documentsProducts.map(f => (
                      <><Card>
                        <CardBody>
                          <Row>
                            <Col>
                              <Label>Descrição</Label>
                              <p style={{ fontWeight: 'bold' }}>
                                <a
                                  href={getOikosFileUrl(f?.arquivo_caminho)} onClick={e => this.openProjAnexo(e, f?.arquivo_caminho)}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {f.documento_desc}
                                </a>
                              </p>
                            </Col>

                            <Col>
                              <Label>Tipo</Label>
                              <p style={{ fontWeight: 'bold' }}>{f.tpDocumento_desc}</p>
                            </Col>
                            <Col>
                              <Button
                                title="Excluir"
                                className="ml-2"
                                color="light"
                                size="sm"
                                onClick={() => {
                                  this.setState({
                                    addDocData: {
                                      documento_id: f.documento_id,
                                    },
                                  })
                                  this.getDocumentsOikos()
                                  this.deleteDocuments(f.documento_id)
                                }}
                              >
                                <i className="ri-delete-bin-6-line" />
                              </Button>
                            </Col>

                          </Row>
                        </CardBody>
                      </Card></>))}




                  </TabPanel>
                  <TabPanel>
                    <Col>
                      <Container>
                        <FormGroup>
                          <label for="exampleFormControlInput1" class="form-label">Para</label>
                          <Input class="form-control" id="exampleFormControlInput1"
                            defaultValue={emailData.destinatario}
                            onChange={e => this.setState({
                              emailData: {
                                ...emailData,
                                destinatario: e.target.value || null,
                              },
                            })} />

                        </FormGroup>
                      </Container>
                    </Col>

                    <Col sm={12}>
                      <FormGroup>
                        <Container>
                          <label for="exampleFormControlInput1" class="form-label">Assunto</label>
                          <Input
                            defaultValue={emailData.assunto}
                            onChange={e => this.setState({
                              emailData: {
                                ...emailData,
                                assunto: e.target.value || null,
                              },
                            })} />
                        </Container>
                      </FormGroup>
                    </Col>
                    <Col sm={12}>

                      <FormGroup>
                        <Container>
                          <label for="exampleFormControlTextarea1" class="form-label">Texto</label>
                          <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                            onChange={e => this.setState({
                              emailData: {
                                ...emailData,
                                texto: e.target.value || null,
                              },
                            })} >
                            {emailData.texto}
                          </textarea>
                        </Container>
                      </FormGroup>
                    </Col>
                    <ModalFooter>
                      <Button
                        type="button"
                        onClick={() => this.setState({ addDocumentData: {}, addMailModalIsOpen: false })}
                        color="light"
                        className="waves-effect"
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="waves-effect waves-light"
                        onClick={() => this.enviarEmail(emailData.destinatario, emailData.assunto, emailData.texto)}
                      >
                        Enviar
                      </Button>
                    </ModalFooter>
                  </TabPanel>
                </Tabs>
              </ModalBody>
            </Modal>
            <ModalConfirmacao
              openModal={this.state.confirmProjAberturaModalOpen}
              onClosed={() => this.setState({ confirmProjAberturaModalOpen: false })}
              onConfirm={() => this.handleOpenProject()}
              title={'Abertura do projeto'}
              subtitle={'Confirma abertura do projeto?'}
              text={'Todas as abas foram conferidas. Confirma a abertura do projeto? Esse processo é irreversível.'}
            />

          </></>
      )
    }

    return null
  }
}

const labelStyle = {
  fontSize: '0.75rem',
  color: '#adb5bd',
  lineHeight: '1.5',
  marginTop: 16,
}

const selOptionsStatus = [
  { value: 0, label: 'Não enviado' },
  { value: 1, label: 'Enviado' },
  { value: 2, label: 'Não efetivado' },
  { value: 3, label: 'Iniciado' },
  { value: 4, label: 'Concluído' },
  { value: 5, label: 'Cancelado' }
]

const mapStateToProps = state => ({
  auth: state.auth,
  technicalDep: state.technicalDep,
  legalSolicitations: state.management.legalSolicitations,
  officialLettersCreated: state.management.officialLettersCreated,
  officialLettersReceived: state.management.officialLettersReceived,
  postOfficialLetterCreatedIsLoading: state.management.postOfficialLetterCreatedIsLoading,
  postOfficialLetterReceivedIsLoading: state.management.postOfficialLetterReceivedIsLoading,
  postOfficialLetterCreatedError: state.management.postOfficialLetterCreatedError,
  postOfficialLetterReceivedError: state.management.postOfficialLetterReceivedError,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getProject,
  getProjectProducts,
  getTeam,
  getProjectTeam,
  getProjectContract,
  getAval,
  getAprov,
  getLegalSolicitations,
  postLegalSolicitation,
  getOfficialLettersCreated,
  postOfficialLetterCreated,
  getOfficialLettersReceived,
  postOfficialLetterReceived,
  updateOfficialLetter,
  generateLegalDemandForOficio,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Project)
